export default {
    app: {
        title: 'Mediasbox',
        description: 'Manage your videos and files',
    },
    onisep: {
        title: 'ONISEP',
        label: {
            synchronised: 'Synchronised',
            notSynchronised: 'Not synchronised',
        },
        labelHint: {
            synchronised: 'This asset meets the rules for ONISEP’s catalogue: every change to it is sent there.',
            notSynchronised: 'This asset does not meet the rules for ONISEP’s catalogue: its changes are not sent there.',
        },
        loading: 'Reading the ONISEP status…',
        loadError: 'Could not read this asset’s ONISEP status.',
        refused: 'Not sent: {conditions}.',
        conditions: {
            not_sendable: 'this kind of asset is never sent',
            not_a_video_collection: 'only video collections are sent',
            retired: 'the asset is in the trash',
            internal: 'the asset is internal',
            outside_pool: 'the asset is not in the shared pool',
            pool_pending: 'its share into the shared pool is awaiting approval',
            pool_rejected: 'its share into the shared pool was rejected',
            pool_under_revision: 'a change requested in the shared pool waits for a moderator’s approval',
            not_exploited: 'the “Exploitation sites internet” field holds none of OnisepTV, Onisep.fr edito and Kiosque',
            no_slug: 'the asset has no slug, which ONISEP requires',
        },
        stillHeld: 'ONISEP keeps the version it received on {date}: nothing is ever removed from its catalogue.',
        lastSent: 'Last sent successfully on {date}.',
        neverSent: 'Not sent to ONISEP yet.',
        pending: {
            waiting: 'A send is waiting.',
            sending: 'Sending…',
            retrying: 'The last attempt failed; next attempt on {date}.',
        },
        sendNow: 'Send now',
        sendNowHint: 'Sends this asset to ONISEP again even if nothing changed, for instance after an incident on their side.',
        sendQueued: 'Send to ONISEP scheduled.',
        sendJoined: 'Send to ONISEP scheduled: the send that was waiting goes now.',
        sendInFlight: 'A send to ONISEP is in progress. If it does not carry your latest changes, send again once it is done.',
        sendRefused: 'ONISEP does not accept this asset for now.',
        sendError: 'Could not schedule the send to ONISEP.',
        journal: {
            title: 'Send log',
            show: 'Show the send log',
            hide: 'Hide the send log',
            empty: 'Nothing sent yet.',
            loadError: 'Could not read the send log.',
            more: 'Show more',
            manual: 'Manual',
            noCall: 'No call',
            state: {
                waiting: 'Waiting',
                sending: 'Sending',
                retrying: 'Failed, retry scheduled',
                sent: 'Sent',
                skipped: 'Not sent',
                failed: 'Given up',
            },
            action: {
                created: 'Create',
                updated: 'Update',
                playlist: 'Playlist',
            },
            http: 'HTTP {code}',
            latency: '{ms} ms',
        },
    },
    workspaces: {
        title: 'Workspaces',
        spaces: 'spaces',
        navigation: {
            media: 'Media',
            shares: 'Shares',
            trash: 'Trash',
            recent: 'Recent',
            unfold: 'Show the workspace\'s lists',
            fold: 'Hide the workspace\'s lists',
            unfoldFolders: 'Show the folders',
            foldFolders: 'Hide the folders',
            unfoldFolder: 'Show the subfolders',
            foldFolder: 'Hide the subfolders',
            folderCount: '{count} item | {count} item | {count} items',
            noFolders: 'No folders',
            foldersError: 'The folders could not be loaded',
        },
        pickerLabel: '{workspace}: change workspace',
        toggleCompact: 'Toggle compact mode',
        expand: 'Expand',
        create: 'Create new workspace',
        search: 'Search workspaces...',
        emptyState: {
            title: 'No workspaces',
            description: 'Create your first workspace to organize your files.',
            action: 'Create workspace',
        },
        noWorkspace: {
            title: 'You have no workspace left',
            description: 'Workspaces hold your videos, subtitles and shares. Create one to pick up where you left off.',
            action: 'Create a workspace',
            restrictedTitle: 'You don\'t have access to any workspace',
            restrictedDescription: 'An administrator of your organization needs to give you access to a workspace, or let you create one.',
        },
        overview: 'Overview',
        searchResults: 'Search results',
        favorites: 'Favorites',
        recent: 'Recent',
        all: 'All workspaces',
        noResults: 'No results for "{query}"',
        empty: 'No files',
        oneFile: '1 file',
        multipleFiles: '{count} files',
        videoStorage: 'Video storage',
        fileStorage: 'File storage',
        storage: 'Storage',
        videos: 'Videos',
        files: 'Files',
        createModal: {
            title: 'Create workspace',
            nameLabel: 'Name',
            nameHint: 'Choose a name for your workspace.',
            namePlaceholder: 'My workspace',
            nameRequired: 'Name is required',
            descriptionLabel: 'Description',
            descriptionHint: 'Add a description to help identify this workspace.',
            descriptionPlaceholder: 'Workspace description...',
            colorLabel: 'Color',
            colorHint: 'Choose a color for your workspace.',
            colorPlaceholder: 'Select a color',
            privacyLabel: 'Privacy',
            privacyHint: 'Control who can access this workspace.',
            public: 'Public',
            private: 'Private',
            publicNote: 'All organization members can view this workspace.',
            privateNote: 'Only invited members can view this workspace.',
            createButton: 'Create',
            defaultName: 'My workspace',
            moreOptions: 'Description, color and visibility',
            success: 'Workspace created. You can now upload your videos.',
            noOrganization: 'No organization selected',
            error: 'Failed to create workspace',
        },
        renameModal: {
            title: 'Edit workspace',
            nameLabel: 'Name',
            nameRequired: 'Name is required',
            descriptionLabel: 'Description',
            colorLabel: 'Color',
            success: 'Workspace updated',
            error: 'Failed to update workspace',
        },
        deleteModal: {
            title: 'Delete workspace',
            titleNamed: 'Delete "{name}"?',
            warning: 'The files in this workspace, their subtitles and their shares will be permanently deleted. This action cannot be undone.',
            lastOneWarning: 'This is your last workspace. Without one, you can\'t upload videos or generate subtitles. You can create a new workspace at any time.',
            confirm: 'Delete workspace',
            success: 'Workspace deleted',
            error: 'Failed to delete workspace',
        },
        pin: {
            success: 'Workspace pinned',
        },
        unpin: {
            success: 'Workspace unpinned',
        },
        pools: 'Pools',
        pendingModeration: 'pending | pending',
        revisionsModeration: '{count} revision to approve | {count} revisions to approve',
        invite: 'Add a member',
        moreActions: 'More actions',
        shared: 'Shared',
        private: 'Private',
        public: 'Public',
        file: 'file',
        menu: {
            open: 'Open',
            viewStats: 'View statistics',
            invite: 'Add members',
            pin: 'Pin to favorites',
            unpin: 'Unpin from favorites',
            rename: 'Rename',
            settings: 'Settings',
            delete: 'Delete',
            moderation: 'Moderation',
        },
        drawerMenu: {
            title: 'Sort and filter',
            sortBy: 'Sort by',
            filters: 'Filters',
            hideEmpty: 'Hide empty workspaces',
            onlyPrivate: 'Only private',
            onlyFavorites: 'Only favorites',
            hideRecent: 'Hide recent',
            reset: 'Reset',
            noMatchingWorkspaces: 'No matching workspaces',
            sort: {
                nameAsc: 'Alphabetical (A\u2013Z)',
                nameDesc: 'Alphabetical (Z\u2013A)',
                contentDesc: 'Most content',
                contentAsc: 'Least content',
                sizeDesc: 'Largest',
                updatedDesc: 'Recently updated',
                createdDesc: 'Recently created',
            },
        },
        backToTop: 'Back to top',
        pinSuccess: 'Workspace pinned',
        unpinSuccess: 'Workspace unpinned',
        pinError: 'Failed to update workspace',
        settings: {
            title: 'Settings',
            globalTitle: 'Global settings',
            placeholder: 'Coming soon...',
            general: 'General',
            members: 'Members',
            design: 'Design',
            player: 'Player',
            tags: 'Tags',
            embed: 'Integration settings',
            advertising: 'Advertising',
            cta: 'Call to action',
            sharing: 'Share link settings',
            export: 'Export',
            shares: 'Share history',
            deletionHistory: 'Deletion history',
            presets: 'Embed presets',
            presetsDescription: 'Manage default embed presets for this workspace',
            sections: {
                general: 'General',
                appearance: 'Appearance',
                content: 'Content',
                display: 'Display',
                integration: 'Integration',
                share: 'Sharing',
                data: 'Data',
            },
            exportSettings: {
                title: 'Export assets',
                subtitle: 'Download your assets data, as a CSV or an Excel workbook.',
                workspace: 'Workspace',
                noWorkspace: 'No workspace where you may export assets.',
                format: 'Export format',
                formatDescription: 'Choose the format for your export file.',
                formatCsv: 'CSV',
                formatXlsx: 'Excel (XLSX)',
                formatHint: {
                    csv: 'Semicolons between columns and a decimal comma: the file opens as columns in a spreadsheet set to French, and a script reads it.',
                    xlsx: 'One sheet, its numbers and dates recognised as such, ready to sort and sum. Up to 1,048,575 assets: beyond that, choose the CSV.',
                },
                analyticsPeriod: {
                    label: 'Statistics period',
                    lifetime: 'Whole lifetime',
                    period: 'A period',
                    from: 'From',
                    until: 'To',
                    lifetimeHint: 'The statistics columns count every session and every rating recorded for each asset.',
                    periodHint: 'Whole days in Coordinated Universal Time (UTC), both included; the period appears in the statistics columns\' headings. A date left empty leaves the period open on that side. It is not kept in a preset.',
                    inverted: 'The start date is after the end date.',
                },
                filters: 'Filters',
                dateRange: 'Date range',
                startDate: 'Start date',
                endDate: 'End date',
                assetTypes: 'Asset types',
                search: 'Search',
                searchPlaceholder: 'Search by name...',
                fields: 'Fields to export',
                fieldsDescription: 'Select which fields to include in the export.',
                selectAll: 'Select all',
                deselectAll: 'Deselect all',
                exportButton: 'Export',
                exporting: 'Exporting...',
                syncSuccess: 'Export ready! Your file is downloading.',
                queueButton: 'Prepare the export',
                queued: 'Your export is being prepared. You will receive an email with a download link when it is ready — it is already listed in the log below.',
                queuedTo: 'Your export is being prepared. You will receive an email at {email} with a download link when it is ready — it is already listed in the log below.',
                asyncNotice: 'From {threshold} assets, an export is prepared in the background: you will receive an email with a download link, valid for 7 days.',
                error: 'Failed to export assets',
                noFields: 'Please select at least one field to export.',
                featureDisabled: 'Asset export is not available for your organization.',
                countBanner: '{count} asset(s) will be exported',
                countLoading: 'Counting assets...',
                collectionSubtypes: 'Collection types',
                collectionVideos: 'Videos',
                collectionAudios: 'Audios',
                collectionImages: 'Images',
                collectionDocuments: 'Documents',
                relation: {
                    label: 'Relations',
                    all: 'All assets',
                    target: 'Targets of a relation',
                    source: 'Sources of a relation',
                    hint: 'Targets: the assets a relation points at. Sources: the assets a relation starts from.',
                },
                organization: {
                    scope: 'Workspaces and moderation',
                    workspaces: 'Workspaces',
                    allWorkspaces: 'Every workspace',
                    workspacesHint: 'None selected: every workspace of the organization. The list offers every one of them, including those you have no seat in, with the number of assets placed in each — pending and rejected included.',
                    workspaceAssets: 'No asset | 1 asset | {count} assets',
                    poolAssets: 'Shared pool · no asset | Shared pool · 1 asset | Shared pool · {count} assets',
                    moderation: 'Moderation status',
                    moderationHint: 'None selected: every status, pending and rejected included.',
                    asyncNotice: 'The organization’s export is always prepared in the background: you will receive an email with a download link, valid for 7 days.',
                },
                log: {
                    title: 'Export log',
                    workspaceDescription: 'Every export of this workspace, whoever asked for it and however it ended. A file prepared in the background can be downloaded for 7 days, by the person who asked for it.',
                    organizationDescription: 'Every export of every workspace and of the whole organization, with the address and the browser it was requested from — kept as long as the organization exists. A file prepared in the background can be downloaded for 7 days, by the person who asked for it.',
                    empty: 'No export yet.',
                    loadError: 'The export log could not be loaded.',
                    loadMore: 'Show more',
                    columns: {
                        date: 'Date',
                        requester: 'Requested by',
                        scope: 'Scope',
                        mode: 'Delivery',
                        format: 'Format',
                        status: 'Status',
                        rows: 'Assets',
                        file: 'File',
                        origin: 'Origin',
                    },
                    erasedAccount: 'Erased account',
                    organizationScope: 'Whole organization',
                    mode: {
                        sync: 'Direct download',
                        async: 'By email',
                    },
                    status: {
                        queued: 'Queued',
                        running: 'In progress',
                        finished: 'Finished',
                        failed: 'Failed',
                    },
                    failureDetail: 'Technical detail: {error}',
                    download: 'Download',
                    expiresOn: 'Until {date}',
                    expired: 'Link expired',
                    sentToRequester: 'Sent to the requester',
                    preparing: 'Being prepared',
                    analyticsPeriod: 'Statistics {period}',
                    periodBetween: 'from {start} to {end}',
                    periodSince: 'since {start}',
                    periodUntil: 'until {end}',
                },
                presets: {
                    label: 'Preset',
                    placeholder: 'Select a preset...',

                    save: 'Save preset',
                    delete: 'Delete',
                    saveTitle: 'Save export preset',
                    nameLabel: 'Preset name',
                    namePlaceholder: 'Enter a name for this preset...',
                    saveSuccess: 'Preset saved successfully.',
                    saveError: 'Failed to save preset.',
                    deleteTitle: 'Delete preset',
                    deleteConfirm: 'Are you sure you want to delete the preset "{name}"?',
                    deleteSuccess: 'Preset deleted.',
                    deleteError: 'Failed to delete preset.',
                    duplicateName: 'A preset with this name already exists.',
                    hint: 'Settings modified \u2014',
                    hintAction: 'Save as preset',
                    renameTitle: 'Rename preset',
                    renameSuccess: 'Preset renamed successfully.',
                    renameError: 'Failed to rename preset.',
                    updateHint: 'Preset settings modified \u2014',
                    updateAction: 'Update preset',
                    updateSuccess: 'Preset updated successfully.',
                    updateError: 'Failed to update preset.',
                },
            },
            embedSettings: {
                title: 'Embed settings',
                subtitle: 'Control which domains are allowed to embed your videos and assets via iframe.',
                restrictDomains: 'Restrict embed domains',
                restrictDomainsDescription: 'When enabled, only the domains listed below will be allowed to embed your content. When disabled, your content can be embedded on any website.',
                allowedDomains: 'Allowed domains',
                allowedDomainsDescription: 'Add the domains that are allowed to embed your content.',
                addDomain: 'Add domain',
                domainPlaceholder: 'example.com',
                wildcardHint: 'Wildcards are supported (e.g. *.example.com to allow all subdomains).',
                removeDomain: 'Remove domain',
                noDomains: 'No domains configured',
                noDomainsDescription: 'Add at least one domain to allow embedding when restrictions are enabled.',
                saveSuccess: 'Embed settings updated',
                saveError: 'Failed to update embed settings',
                invalidDomain: 'Please enter a valid domain name',
                duplicateDomain: 'This domain is already in the list',
                domainRequired: 'Add at least one allowed domain, or turn off the domain restriction — otherwise embedding would be blocked everywhere.',
                domainCount: '{count} domain(s)',
                lockPresetCustomization: 'Lock player customization',
                lockPresetCustomizationDescription: 'When enabled, users can only apply predefined presets. They cannot modify player settings or create new presets.',
            },
            sharingSettings: {
                title: 'Share links',
                orgSubtitle: 'Configure default expiration applied when users create new share links across your organization.',
                workspaceSubtitle: 'Set the default expiration and the logo of share links created in this workspace.',
                defaultExpirationEnabled: 'Enable expiration by default',
                defaultExpirationEnabledDescription: 'When enabled, new share links have an expiration date pre-filled. Users can still disable it manually for each link.',
                defaultExpirationDays: 'Default duration',
                defaultExpirationDaysDescription: 'Number of days until a new share link expires by default.',
                daysSuffix: 'days',
                daysOutOfRange: 'Please enter a number of days between 1 and 3650.',
                customLogoTitle: 'Custom share logo',
                customLogoDescription: 'Upload a custom logo displayed in the header of public share pages. If empty, the platform logo is used as fallback.',
                customLogoHelper: 'PNG, JPEG or WebP. Recommended size: 200×200px.',
                customLogoInheritedFromOrg: 'This workspace uses the organization\'s custom logo. Upload a new logo to override it for this workspace.',
                customLogoError: 'Could not save the custom logo. Please try again.',
            },
            inheritance: {
                inherit: 'Use the "All workspaces" settings',
                inheritHint: 'This workspace follows the settings defined for all workspaces, and changes to them apply here.',
                openOrg: 'Open the "All workspaces" settings',
                custom: 'Customize for this workspace',
                customHint: 'This workspace has its own settings, which no longer follow "All workspaces".',
            },
            advertisingSettings: {
                title: 'Advertising',
                subtitle: 'Configure VAST advertising settings for embedded content in this workspace.',
                orgSubtitle: 'Configure default VAST advertising settings for all workspaces in your organization.',
                enabled: 'Enable VAST advertising',
                enabledDescription: 'When enabled, VAST ads will be displayed on embedded content. You must provide a valid VAST tag URL below.',
                vastUrl: 'VAST tag URL',
                vastUrlDescription: 'Enter the URL of your VAST tag. This URL will be used to fetch and display video ads.',
                vastUrlPlaceholder: 'https://example.com/vast-tag.xml',
                skipAfter: 'Forced ad skip',
                skipAfterDescription: 'After this long, the player offers to skip the ad even when the VAST tag does not provide for it. The shorter of the two wins, so an ad the advertiser makes skippable sooner stays so. Leave empty to let the tag decide. Note: forcing a skip before the advertiser\'s own offset under-delivers the ad and may fall outside your network\'s terms.',
                skipAfterPlaceholder: 'No forced skip',
                skipAfterUnit: 'seconds',
                excludedDomains: 'Excluded domains',
                excludedDomainsDescription: 'Add domains where ads should not be displayed. Embeds on these domains will not show ads.',
                addDomain: 'Add domain',
                domainPlaceholder: 'example.com',
                wildcardHint: 'Wildcards are supported (e.g. *.example.com to exclude all subdomains).',
                noDomains: 'No excluded domains',
                noDomainsDescription: 'All embed domains will display ads. Add domains here to exclude them from ad serving.',
                saveSuccess: 'Advertising settings updated',
                saveError: 'Failed to update advertising settings',
                invalidDomain: 'Please enter a valid domain name',
                duplicateDomain: 'This domain is already in the list',
                domainCount: '{count} domain(s)',
            },
            tagSettings: {
                title: 'Tags',
                subtitle: 'Manage workspace tags and control how tags can be applied to assets.',
                restrictToExisting: 'Restrict to existing tags',
                restrictToExistingDescription: 'When enabled, users can only apply pre-existing tags to assets. When disabled, users can create new tags freely when tagging assets.',
                tagList: 'Tags',
                tagCount: '{count} tag(s)',
                addTag: 'Add tag',
                tagPlaceholder: 'Tag name',
                noTags: 'No tags yet',
                noTagsDescription: 'Create tags to organize and categorize your assets.',
                orgScope: 'Organization',
                workspaceScope: 'Workspace',
                filterByTag: 'View assets with this tag',
                deleteTag: 'Delete tag',
                deleteTagConfirmTitle: 'Delete tag',
                deleteTagConfirm: 'This tag is used by {count} asset(s). Deleting it will remove it from all assets. This action cannot be undone.',
                deleteTagConfirmUnused: 'Are you sure you want to delete this tag? This action cannot be undone.',
                inherited: 'Inherited from organization',
                overridden: 'Custom',
                resetTitle: 'Reset settings',
                resetDescription: 'Remove customizations and revert to the organization\'s default settings.',
                resetToDefaults: 'Reset',
                resetConfirmTitle: 'Reset tag settings',
                resetConfirm: 'This will remove all workspace-level tag settings and revert to the organization defaults. This action cannot be undone.',
                createSuccess: 'Tag created',
                createError: 'Failed to create tag',
                deleteSuccess: 'Tag deleted',
                deleteError: 'Failed to delete tag',
                saveSuccess: 'Tag settings updated',
                saveError: 'Failed to update tag settings',
                resetSuccess: 'Tag settings reset to organization defaults',
                resetError: 'Failed to reset tag settings',
                duplicateTag: 'This tag already exists',
                assets: 'asset(s)',
            },
            generalSettings: {
                title: 'General',
                subtitle: 'Manage workspace name, description, and visibility settings.',
                basicInfo: 'Basic information',
                basicInfoDescription: 'Update the workspace name and description.',
                nameLabel: 'Name',
                namePlaceholder: 'My workspace',
                nameRequired: 'Name is required',
                descriptionLabel: 'Description',
                descriptionPlaceholder: 'Workspace description...',
                appearance: 'Appearance',
                appearanceDescription: 'Customize the visual identity of your workspace.',
                colorLabel: 'Color',
                access: 'Access',
                accessDescription: 'Control who can access this workspace.',
                privateLabel: 'Private workspace',
                publicNote: 'All organization members can view this workspace.',
                privateNote: 'Only invited members can view this workspace.',
                dangerZone: 'Danger zone',
                dangerZoneDescription: 'Irreversible actions that affect your workspace.',
                deleteWorkspace: 'Delete workspace',
                deleteWorkspaceDescription: 'Permanently delete this workspace and all its contents.',
                deleteButton: 'Delete',
                saveSuccess: 'Settings saved successfully',
                saveError: 'Failed to save settings',
            },
            globalTeam: {
                title: 'Team overview',
                subtitle: 'All members across your workspaces.',
                search: 'Search members...',
                workspaceFilter: 'Filter by workspace',
                allWorkspaces: 'All workspaces',
                table: { name: 'Name', workspace: 'Workspace', role: 'Role', status: 'Status', joinedAt: 'Joined' },
                memberCount: '{count} member(s)',
                empty: { title: 'No members found', description: 'Members will appear here when workspaces have team members.' },
            },
            globalTags: {
                title: 'Tags overview',
                subtitle: 'All tags across your organization.',
                search: 'Search tags...',
                tagCount: '{count} tag(s)',
                table: { name: 'Tag', assetCount: 'Assets' },
                viewAssets: 'View assets',
                empty: { title: 'No tags found', description: 'Tags will appear here when your organization has tags.' },
            },
            globalEmbed: {
                title: 'Embed settings',
                subtitle: 'Embed domain restrictions and configuration.',
                placeholder: { title: 'Per-workspace configuration', description: 'Embed settings are configured individually for each workspace. Go to a workspace\'s settings to manage embed domain restrictions.' },
            },
            sharesSettings: {
                title: 'Shares',
                subtitle: 'Manage share links for this workspace.',
                listTitle: 'Share links',
                search: 'Search shares...',
                count: '{count} share(s)',
                noResults: 'No link matches these filters.',
                clearFilters: 'Clear filters',
                create: 'Create a link',
                pickTitle: 'Choose what the link shares',
                assetCount: '{count} asset | {count} assets',
                showMore: 'Show more',
                sort: {
                    title: 'Sort by',
                    newest: 'Newest',
                    oldest: 'Oldest',
                    name: 'Name',
                    views: 'Most opened',
                    expiry: 'Expiring soonest',
                },
                error: {
                    title: 'The share links could not be loaded',
                    description: 'Check your connection and try again.',
                    retry: 'Retry',
                },
                table: {
                    name: 'Name',
                    status: 'Status',
                    assets: 'Assets',
                    views: 'Opens',
                    createdAt: 'Created',
                    expiresAt: 'Expires',
                    actions: 'Actions',
                },
                neverExpires: 'Never',
                neverExpiresLabelled: 'Never expires',
                expiresOn: 'Expires {date}',
                expiredChip: 'Expired',
                status: {
                    active: 'Active',
                    inactive: 'Inactive',
                    expired: 'Expired',
                    exhausted: 'Exhausted',
                },
                filter: {
                    all: 'All',
                },
                unlimited: 'Unlimited',
                copyUrl: 'Copy link',
                copySuccess: 'Share link copied to clipboard',
                edit: 'Edit share',
                editSubtitle: 'Adjust the settings of this share link',
                editSuccess: 'Share updated',
                editError: 'Failed to update share',
                active: 'Active',
                activeHint: 'When disabled, the share link will no longer be accessible.',
                passwordUnchanged: 'Leave empty to keep current password',
                deleteConfirmTitle: 'Delete share',
                deleteConfirm: 'Are you sure you want to delete this share? This will revoke access for anyone using this link.',
                deleteSuccess: 'Share deleted',
                deleteError: 'The share could not be deleted.',
                copyError: 'The link could not be copied.',
                stats: {
                    button: 'View statistics',
                    title: 'Statistics — {name}',
                    lifetimeViews: 'Total opens',
                    lifetimeViewsHint: 'How many times the share link was opened (counted once per visitor per 24h, all-time), regardless of which content was then consumed.',
                    viewsHint: 'Content actually consumed over the period: a play (>10s) for videos and audios, an open for images.',
                    scopeNote: 'Engagement for plays opened through this share link.',
                    tabs: {
                        overview: 'Overview',
                        contents: 'Contents',
                        email: 'Email',
                    },
                    contentsEmpty: 'This share has no playable content.',
                    openContent: 'Open content',
                    remainingViews: 'Opens left',
                    lastViewed: 'Last opened',
                    recentVisits: 'Recent opens',
                    visitThroughLink: 'Share link',
                    visitThroughRecipient: 'Personal link',
                    range: {
                        last7days: 'Last 7 days',
                        last30days: 'Last 30 days',
                        last90days: 'Last 90 days',
                    },
                    empty: {
                        title: 'No engagement data yet',
                        description: 'Detailed statistics are recorded from the moment this feature shipped. Share your link — plays will show up here.',
                    },
                    email: {
                        empty: {
                            title: 'No email sent yet',
                            description: 'Send this share by email: each recipient gets a personal link, and its opens will show here.',
                        },
                        kpi: {
                            sent: 'Sent',
                            delivered: 'Delivered',
                            opened: 'Opened',
                            clicked: 'Clicked',
                        },
                        sentCaption: '{count} recipient | {count} recipients',
                        deliverability: '{rate}% deliverability',
                        opensTotal: '{count} opens total',
                        clicksTotal: '{count} clicks total',
                        funnelTitle: 'Email funnel',
                        recipientsTitle: 'By recipient',
                        col: {
                            recipient: 'Recipient',
                            status: 'Status',
                            opens: 'Opens',
                            views: 'Views',
                            lastEvent: 'Last event',
                        },
                        status: {
                            pending: 'Pending',
                            sent: 'Sent',
                            delivered: 'Delivered',
                            opened: 'Opened',
                            clicked: 'Clicked',
                            bounced: 'Bounced',
                            failed: 'Failed',
                        },
                        footnote: 'Open & click tracking is automatic — each recipient opens a personal link.',
                        copyLink: 'Copy personal link',
                        linkCopied: 'Personal link copied',
                    },
                },
                empty: {
                    title: 'No shares',
                    description: 'Share links created from this workspace will appear here.',
                },
            },
            deletionHistorySettings: {
                title: 'Deletion history',
                subtitle: 'View and restore recently deleted items from this workspace.',
                overviewSubtitle: 'View and restore recently deleted items from the workspaces where you can restore them.',
                retentionWarning: 'Deleted items can be restored for 30 days. After that, they are deleted for good automatically and can no longer be restored.',
                billingNote: 'Items in the trash stay billed until they are deleted for good, by you or automatically after 30 days.',
                billingCost: 'The trash currently costs ≈ {amount} a month.',
                purge: 'Delete for good',
                purgeConfirmTitle: 'Delete for good?',
                purgeConfirmMessage: '“{name}” will be erased for good, with its encoded versions and its subtitles. This cannot be undone and the item can no longer be restored.',
                purgeSuccess: 'Item deleted for good.',
                purgeError: 'Could not delete this item for good.',
                purgeLocked: 'This item was validated in the pool: only a moderator of the pool can delete it for good.',
                empty: 'Empty the trash',
                emptyConfirmTitle: 'Empty the trash?',
                emptyConfirmMessage: 'The {count} items in the trash will be erased for good, with their encoded versions and their subtitles. This cannot be undone.',
                emptyConfirmSaving: 'Saving from the next measurement: ≈ {amount} a month.',
                emptySuccess: '{count} item(s) deleted for good.',
                emptyLocked: '{count} item(s) validated in the pool were kept for its moderators.',
                emptyError: 'Could not empty the trash.',
                search: 'Search deleted items...',
                listTitle: 'Deleted items',
                // Who put it in the trash when nobody did (`utils/trashReason.ts`).
                reasons: {
                    awaiting_credit_expired: 'Automatically: a video left waiting seven days for credit',
                },
                emptyTitle: 'No deleted items',
                emptyDescription: 'Items deleted from this workspace will appear here for 30 days.',
                overviewEmptyDescription: 'Items deleted from those workspaces will appear here for 30 days.',
                noResults: 'No deleted item matches this search.',
                columns: {
                    name: 'Name',
                    type: 'Type',
                    deletedBy: 'Deleted by',
                    deletedAt: 'Deleted at',
                    daysRemaining: 'Time left',
                    workspace: 'Workspace',
                    actions: 'Actions',
                },
                restore: 'Restore',
                restoreSuccess: 'Item restored successfully.',
                restoreError: 'Failed to restore item.',
                bulkRestore: 'Restore selection ({count})',
                bulkRestoreSuccess: '{count} item(s) restored successfully.',
                daysRemaining: '{count} day(s) left',
                expired: 'Expired',
                noLongerRestorable: 'No longer restorable',
                restoreConfirmTitle: 'Restore item',
                restoreConfirmMessage: 'Are you sure you want to restore this item? It will be moved back to its original location.',
                bulkRestoreConfirmTitle: 'Restore items',
                bulkRestoreConfirmMessage: 'Are you sure you want to restore {count} item(s)? They will be moved back to their original locations.',
            },
            playerLogo: {
                title: 'Player logo',
                description: 'Upload a logo to display on all embedded players in this workspace.',
                orgDescription: 'Upload a default logo for all embedded players across your organization. Workspaces can override this with their own logo.',
                upload: 'Upload logo (PNG, WebP)',
                remove: 'Remove',
                position: 'Position',
                positionTopLeft: 'Top left',
                positionTopRight: 'Top right',
                positionBottomLeft: 'Bottom left',
                positionBottomRight: 'Bottom right',
                opacity: 'Opacity',
                clickUrl: 'Click URL',
                clickUrlDesc: 'Opens this URL when the logo is clicked',
                helper: 'PNG or WebP. Recommended: transparent background.',
                saved: 'Logo settings saved',
                uploadError: 'Failed to upload logo',
                saveError: 'Failed to save logo settings',
                inheritedFromOrg: 'Using the logo defined in organization settings. Upload a logo here to override it for this workspace.',
            },
            presetManagement: {
                title: 'Embed presets',
                description: 'Configure default player settings and appearance for this workspace',
                filterAll: 'All',
                filterVideo: 'Video',
                filterAudio: 'Audio',
                filterImage: 'Image',
                filterDocument: 'Document',
                filterCollection: 'Collection',
                emptyState: {
                    title: 'No presets',
                    description: 'Create a preset from the Developer tab on any asset.',
                },
                createPreset: 'Create preset',
                orgPresets: 'Organization presets',
                orgPresetsDesc: 'These presets are shared across all workspaces',
                inheritedBadge: 'Inherited',
                summary: {
                    optionsChanged: '{count} custom option(s)',
                    noCustomOptions: 'Default settings',
                },
                details: {
                    playback: 'Playback',
                    display: 'Display',
                    features: 'Features',
                    appearance: 'Appearance',
                    dimensions: '{width} × {height}',
                    noLogo: 'No logo',
                },
            },
        },
        members: {
            title: 'Members',
            subtitle: 'Manage workspace members and their roles',
            listTitle: 'Members',
            invite: 'Add a member',
            inviteSuccess: 'Invitation sent successfully',
            search: 'Search members...',
            count: '{count} member(s)',
            empty: {
                title: 'No members yet',
                description: 'Add members of the organization to collaborate on this workspace.',
            },
            addModal: {
                memberLabel: 'Organization member',
                allSeated: 'Every member of the organization already has a seat here.',
                personLabel: 'Member or email address',
                seatHint: '{name} is already in the organization: they get access to this workspace straight away.',
                inviteHint: 'This address is not in the organization: an invitation is emailed to it, and accepting brings the person into the organization as a member, with the role chosen here in this workspace.',
                alreadySeated: 'This person already has a seat in this workspace.',
                cannotSeat: 'You may not add a member to this workspace.',
                cannotInvite: 'You may not invite somebody from outside the organization.',
                refusals: {
                    notSeatable: 'No member of the organization matches that address.',
                    invalidAddress: 'That email address or role is not valid.',
                    inviteForbidden: 'You may not send this invitation.',
                    workspaceGone: 'This workspace no longer exists.',
                    alreadyMember: 'That address already belongs to a member of the organization: add them to the workspace directly.',
                    rateLimited: 'Too many invitations sent: wait a moment, or try again tomorrow if the organization has spent its daily budget.',
                    noRelay: 'Email is unavailable: nothing was created, because the link only ever travels in the message.',
                },
            },
            pending: {
                title: 'Pending invitations',
                note: 'These people are not in the organization yet. The invitation link only travels in the email — it is shown nowhere here.',
                empty: 'No pending invitation.',
                invitedBy: 'Invited by {name}',
                orgRole: 'Joins the organization as {role}',
                table: {
                    email: 'Address',
                    workspace: 'Workspace',
                    role: 'Role',
                    expires: 'Expires',
                },
                actions: {
                    resend: 'Send again',
                    cancel: 'Withdraw invitation',
                },
                toast: {
                    sent: 'Invitation sent to {email}',
                    resent: 'Invitation sent again: the previous link no longer works',
                    resendError: 'The invitation could not be sent again',
                    resendRefused: 'This invitation can no longer be sent again as it stands — the role it offers no longer exists. Withdraw it and invite this person again.',
                    cancelled: 'Invitation withdrawn',
                    cancelError: 'The invitation could not be withdrawn',
                    gone: 'That invitation is no longer pending',
                },
            },
            status: {
                active: 'Active',
                pending: 'Pending',
            },
            roles: {
                owner: 'Owner',
                admin: 'Admin',
                editor: 'Editor',
                viewer: 'Viewer',
            },
            filters: {
                role: 'Role',
                status: 'Status',
                clear: 'Clear filters',
            },
            stats: {
                total: 'Total members',
                active: 'Active',
                pending: 'Pending',
            },
            table: {
                name: 'Name',
                role: 'Role',
                status: 'Status',
                joinedAt: 'Joined',
                actions: 'Actions',
            },
            inviteModal: {
                title: 'Invite member',
                emailLabel: 'Email address',
                emailPlaceholder: "name{'@'}example.com",
                roleLabel: 'Role',
                submit: 'Send invitation',
            },
            roleSelect: {
                label: 'Role',
                ariaLabel: 'Role: {role}. Change role',
                builtinHeader: 'Built-in roles',
                customHeader: 'Custom roles',
                importedHeader: 'Imported roles',
                importedLabel: 'Imported role — {list}',
                and: 'and',
                clauseSeparator: '; ',
                importedOrigin: 'Original name: {name}',
                allows: 'Sees the workspace, and can {list}',
                onlyViews: 'Sees the workspace and everything in it, without changing anything',
                confirm: {
                    title: "Change {name}'s role?",
                    message: 'In the “{workspace}” workspace, {name} will move from the “{from}” role to the “{to}” role.',
                    gains: 'Will now be able to',
                    loses: 'Will no longer be able to',
                    same: 'Both roles grant exactly the same rights.',
                    submit: 'Change role',
                },
                success: "{name}'s role changed: “{role}”",
            },
            delete: {
                title: 'Remove member',
                warning: 'This member will lose access to all assets in this workspace. This action cannot be undone.',
                confirm: 'Remove',
                success: 'Member removed successfully',
                error: 'The member could not be removed from the workspace.',
            },
        },
    },
    title: 'Assets',
    description: 'Manage your videos and files',
    placeholder: 'Coming soon...',
    actions: {
        preview: 'Preview',
        share: 'Share',
        embed: 'Embed',
        more: 'More actions',
    },
    miniPlayer: {
        collapse: 'Minimize',
        expand: 'Expand',
        fullscreen: 'Open in modal',
        minimize: 'Minimize to mini player',
        close: 'Close mini player',
        play: 'Play',
        pause: 'Pause',
        openLarge: 'Open {name} full size',
    },
    assetDetail: {
        tabs: {
            overview: 'Overview',
            metadata: 'Metadata',
            files: 'Files',
            subtitles: 'Subtitles',
            chapters: 'Chapters',
            interactivity: 'Interactivity',
            analytics: 'Analytics',
            contents: 'Contents',
            developer: 'Developer',
            history: 'History',
            shares: 'Shares',
        },
    },
    assetShares: {
        emptyTitle: 'This asset has never been shared',
        emptyDescription: 'Every link that opens this content — made on it or on a folder containing it, active or not — will be listed here.',
        create: 'Share',
    },
    history: {
        emptyTitle: 'No changes yet',
        emptyDescription: 'Changes to this content’s record — made directly or proposed to the shared pool’s moderators — will show here.',
        error: {
            title: 'The history could not be loaded',
            description: 'Something went wrong reading this content’s history.',
            retry: 'Try again',
        },
        state: {
            draft: 'Draft',
            submitted: 'Awaiting approval',
            approved: 'Approved and applied',
            rejected: 'Refused',
            abandoned: 'Abandoned',
            cancelled: 'Cancelled',
            applied: 'Changed',
        },
        madeBy: 'By {name} on {date}',
        madeByKey: 'Through the API key “{name}” on {date}',
        proposedBy: 'Proposed by {name} on {date}',
        decided: {
            approved: 'Approved by {name} on {date}',
            rejected: 'Refused by {name} on {date}',
        },
        amendedBy: 'Retouched by {name} before its approval',
        noteLine: 'Message: “{reason}”',
        reasonLine: '“{reason}”',
        formerMember: 'a former member',
        columns: {
            field: 'Field',
            before: 'Before',
            after: 'After',
            proposed: 'Proposed',
        },
        fields: {
            name: 'Title',
            description: 'Description',
            excerpt: 'Summary',
            copyright_info: 'Rights',
            language: 'Language',
            license_type: 'Licence',
            tags: 'Tags',
            metadata: 'Custom field',
        },
        empty: '(empty)',
        unknownTag: '(deleted tag)',
        more: 'Show more',
    },
    trim: {
        launch: 'Trim video',
        launchDesc: 'Trim the start or end',
        title: 'Trim video',
        lossless: 'Lossless — the original is kept',
        destination: 'Destination',
        startLabel: 'Start',
        endLabel: 'End',
        startHandle: 'Trim start',
        endHandle: 'Trim end',
        useCurrent: 'Set to current position',
        useCurrentStart: 'Set start to current position',
        useCurrentEnd: 'Set end to current position',
        keptDuration: 'Kept duration',
        removed: '−{duration} removed',
        playSegment: 'Play clip',
        pausePreview: 'Pause',
        replay: 'Replay from start',
        destExisting: 'Modify this video',
        destExistingHint: 'Instant · keeps existing links & embeds',
        destNew: 'New video',
        destNewHint: 'Independent, re-encoded file',
        soon: 'Soon',
        leak: 'Applied to in-app playback and embeds. The downloadable source stays complete.',
        reset: 'Reset',
        cancel: 'Cancel',
        apply: 'Apply trim',
        applyWhere: 'Apply the trim to…',
        applied: 'Trim applied',
        applyError: 'Could not apply the trim',
        loadError: 'Could not load the video',
        clipNameSuffix: '{name} (clip)',
        clipCreating: 'Creating your clip…',
        clipError: 'Could not create the clip',
        derivedFrom: 'Clip of',
        trimmedTo: 'Trimmed to {duration}',
        restoreOriginal: 'Restore original',
        restored: 'Original restored',
    },
    overview: {
        title: 'Overview',
        description: 'General information about this file',
        playerPlaceholder: 'Player (coming soon)',
        form: {
            title: 'General information',
            name: 'Name',
            description: 'Description',
            slug: 'Slug',
            slugEdit: 'Edit slug',
            slugGenerate: 'Generate from name',
            slugNone: 'No slug. “Generate from name” suggests one.',
            slugWarning: 'Warning: if this content is already published, changing the slug will modify its URL. Are you sure you want to change it?',
            tags: 'Tags',
            noTags: 'No tags',
            tagsPlaceholder: 'Search or add tags...',
            tagsPlaceholderRestricted: 'Search tags...',
            manageTags: 'Manage',
            createTag: 'Create tag: {name}',
            cancel: 'Cancel',
            tagCreateError: 'Failed to create tag',
        },
        details: {
            title: 'File details',
            subtitle: 'Technical metadata',
            addedOn: 'Added on',
            duration: 'Duration',
            format: 'Format',
            size: 'Size',
            itemCount: 'Items',
            oneItem: '1 item',
            multipleItems: '{count} items',
            sizeUnits: {
                bytes: 'B',
                kb: 'KB',
                mb: 'MB',
                gb: 'GB',
                tb: 'TB',
            },
            status: 'Status',
            owner: 'Owner',
        },
        aiAssistant: {
            title: 'AI Assistant',
            subtitles: 'Generate subtitles',
            chapters: 'Chapter this video',
            summarize: 'Summarize content',
            aiWriting: 'Write titles and descriptions',
            seoKeywords: 'Generate SEO keywords',
        },
        channelStatus: {
            title: 'Published in a channel | Published in {count} channels',
            status: {
                published: 'Published',
                scheduled: 'Scheduled',
                draft: 'Draft',
                archived: 'Retired',
            },
        },
        quickActions: {
            title: 'Quick actions',
            subtitle: 'Add, share or export in one click',
            addToCollection: 'Add to collection',
            addToCollectionDesc: 'Organize in a playlist',
            newCollection: 'New collection',
            noCollectionTitle: 'No collection in this workspace',
            noCollectionDescription: 'Create a collection to add this media to it.',
            createClip: 'Create a clip',
            createClipDesc: 'Short-form clip for social media',
            addToChannel: 'Add to channel',
            addToChannelDesc: 'Publish to a portal',
            subtitles: 'Generate subtitles',
            subtitlesDesc: 'Generate with Scribe AI',
            aiWriting: 'AI Writing',
            aiWritingDesc: 'Generate titles, descriptions and more',
            download: 'Download',
            downloadDesc: 'Get the source file',
            addContent: 'Add content',
            addContentDesc: 'Select items',
        },
        embed: {
            title: 'Embed',
            subtitle: 'Embed this asset on your website',
            embedUrl: 'Embed URL',
            iframeCode: 'Iframe code',
            copyUrl: 'Copy URL',
            copyIframe: 'Copy iframe',
            copied: 'Copied!',
            loading: 'Loading embed...',
            error: 'Failed to load embed information',
        },
        error: {
            title: 'Loading error',
            description: 'Unable to load asset information',
            retry: 'Retry',
        },
        // A video measured and not encoded for want of credit (`AwaitingCreditPanel.vue`).
        awaitingCredit: {
            title: 'Awaiting credit',
            description: 'Your video has arrived, but the organization\'s credit does not cover its first month of storage: it is not encoded yet. Top up your credit, and the encoding resumes by itself within minutes.',
            trash: 'Without a top-up, after seven days of waiting, the video goes back to its previous version if it has one that plays, and to the trash otherwise.',
            topUp: 'Top up your credit',
            member: 'Only billing managers can top up the credit: ask one of them.',
        },
        encoding: {
            title: {
                video: 'Your video is being prepared',
                audio: 'Your audio file is being prepared',
                image: 'Your image is being processed',
                document: 'Your document is being processed',
                default: 'Your file is being prepared',
            },
            description: {
                video: 'We are encoding your file so it can be played smoothly on any device. This can take a few minutes for longer videos.',
                audio: 'We are preparing your audio file so it can be played on any device.',
                image: 'We are analyzing your image and generating previews.',
                document: 'We are processing your document and generating previews.',
                default: 'We are preparing your file.',
            },
            hint: 'You can leave this page — processing will continue in the background.',
            pending: 'Waiting in queue',
            uploading: 'Uploading file',
            fetchingSource: 'Downloading from the link',
            extractingMetadata: 'Analyzing file',
            extractingText: 'Reading the text',
            generatingThumbnails: 'Generating previews',
            drawingWaveform: 'Drawing the waveform',
            buildingFilmstrip: 'Building the preview strip',
            encoding: 'Encoding for streaming',
        },
        emptyCollection: {
            title: 'This collection is empty',
            description: 'Add content to see a preview here.',
        },
        previewNotAvailable: 'Preview not available for this file type',
        saveSuccess: 'Changes saved',
        saveError: 'Failed to save',
        thumbnails: {
            title: 'Thumbnails',
            add: 'Add',
            import: 'Import image',
            capture: 'Capture from video',
            captureModal: {
                title: 'Capture thumbnail',
                description: 'Navigate through the video and capture the desired frame.',
                generate: 'Capture',
                play: 'Play',
                pause: 'Pause',
                stepBack: 'Previous frame',
                stepForward: 'Next frame',
                loadingVideo: 'Loading video...',
                loadError: 'Failed to load video',
                retry: 'Retry',
                mute: 'Mute',
                unmute: 'Unmute',
                queueFull: 'The processing queue is full. Try again in a few minutes.',
                capturing: 'Capturing the frame…',
            },
            empty: 'No thumbnails available',
            recommendation: 'Recommended: {width}×{height} ({ratio}), {formats}, max {maxSize} MB',
            selected: 'Selected',
            effective: 'Shown by default',
            download: 'Download',
            delete: 'Delete',
            deleteConfirm: {
                title: 'Delete thumbnail',
                message: 'Are you sure you want to delete this thumbnail? This action cannot be undone.',
            },
            deleteSuccess: 'Thumbnail deleted',
            deleteError: 'Failed to delete thumbnail',
            selectSuccess: 'Thumbnail selected',
            selectError: 'Failed to select thumbnail',
            uploadSuccess: 'Thumbnail uploaded',
            uploadError: 'Failed to upload thumbnail',
            fileTooLarge: 'The image is too large. Maximum size is 10 MB.',
            invalidFileType: 'Invalid file type. Only JPEG, PNG and WebP images are accepted.',
            generateSuccess: 'Thumbnail generation started',
            captureSuccess: 'Thumbnail captured. Save to apply it.',
            generateError: 'Failed to generate thumbnail',
        },
    },
    metadata: {
        title: 'Metadata',
        description: 'Manage custom metadata for this asset',
        emptyTitle: 'No metadata schema',
        emptyDescription: 'No custom metadata fields have been defined for this asset type. Contact your administrator to configure metadata schemas.',
        viewDetail: 'Details',
        valueRefused: 'The metadata was not saved: a value was refused. Check the fields you changed.',
        ideoCompletionFailed: 'The card could not be read: the fields it fills in were left as they were.',
        error: {
            title: 'Failed to load metadata',
            description: 'An error occurred while loading the metadata. Please try again.',
            retry: 'Retry',
        },
    },
    folder: {
        root: 'Root',
        browse: 'Browse folder',
        createTitle: 'Create folder',
        name: 'Folder name',
        selectionHint: '{count} selected item will be moved into this folder | {count} selected items will be moved into this folder',
        selectFolder: 'Select folder',
        searchPlaceholder: 'Search folders...',
        selectWorkspaceFirst: 'Select a workspace first',
    },
    transfers: {
        drawer: {
            title: 'Transfers',
        },
        tabs: {
            uploads: 'Uploads',
            exports: 'Exports',
        },
        exports: {
            empty: 'No exports',
            emptyHelper: 'Your ZIP archives and subtitled videos will appear here',
            inProgress: '{count} export in progress | {count} exports in progress',
            readyOne: 'Your export is ready',
            readyMany: '{count} exports are ready',
            failedCount: 'One export failed | {count} exports failed',
            preparing: 'Preparing…',
            ready: 'Ready',
            failed: 'Failed',
            download: 'Download',
            later: 'Later',
            dismiss: 'Dismiss',
            view: 'View',
            retry: 'Retry',
            remove: 'Remove',
            errorGeneric: 'The export failed.',
            errorNetwork: 'Connection lost while tracking the export.',
            phase: {
                compressing: 'Compressing',
            },
            source: {
                zip: 'Media library',
                'burned-video': 'Scribe',
                clip: 'Clips',
            },
            kind: {
                zip: 'ZIP archive',
                'burned-video': 'Subtitled video',
                clip: 'Clip',
            },
        },
    },
    upload: {
        fab: 'Upload files',
        openDrawer: 'View uploads',
        drawer: {
            title: 'Uploads',
            clearCompleted: 'Clear completed',
            clearFailed: 'Clear failed',
            clearAll: 'Clear all',
            cancelAllActive: 'Cancel all in progress',
            clearInactive: 'Clear history',
            empty: 'No uploads yet',
            emptyHelper: 'Drop files here or use the upload button',
            keepTabOpenWarning: 'Keep this tab open until uploads finish. Closing or refreshing the tab will interrupt them.',
        },
        dropZone: {
            clickOrDrag: 'Click or drag files here',
            helper: 'Maximum file size: {size} MB',
            dropHere: 'Drop files here!',
        },
        dropOverlay: {
            title: 'Drop files to upload',
            subtitle: 'Files will be uploaded to the current workspace',
        },
        workspacePicker: {
            title: 'Choose a workspace',
            hint: 'Which workspace should this file go to? | Which workspace should these {count} files go to?',
            confirm: 'Upload',
            empty: 'You have no workspace to upload this file to. | You have no workspace to upload these {count} files to.',
            emptyAction: 'Create a workspace',
        },
        miniDock: {
            uploading: '{count} upload in progress | {count} uploads in progress',
            keepTabOpenWarning: 'Don\'t close or refresh this tab — uploads will be interrupted.',
        },
        progress: {
            files: 'files',
            speed: 'Speed',
            eta: 'Time remaining',
        },
        item: {
            pending: 'Waiting...',
            uploading: 'Uploading',
            paused: 'Paused',
            completed: 'Completed',
            failed: 'Failed',
            cancelled: 'Cancelled',
            queued: 'Queued',
        },
        actions: {
            pause: 'Pause',
            resume: 'Resume',
            cancel: 'Cancel',
            retry: 'Retry',
            remove: 'Remove',
            topUp: 'Top up your credit',
        },
        errors: {
            fileTooLarge: 'File exceeds maximum size of {size} MB',
            queueFull: 'Upload queue is full ({max} files max). Wait for some uploads to finish before adding more.',
            queueWouldExceed: 'Can\'t add files — queue limit is {max} items.',
            notAllowed: 'Your role in this workspace does not allow adding files to it',
        },
        failure: {
            network: 'The connection dropped during the upload. Check your network and retry: the transfer resumes where it stopped.',
            interrupted: 'The transfer was interrupted along the way. Retry: it resumes from what the server already received.',
            tooLarge: 'This file is larger than we accept.',
            refused: 'The server refused this file. Check that it is a readable media file.',
            forbidden: 'You may no longer add files to this workspace. Your session may have expired: sign in again.',
            destinationGone: 'The workspace, folder or media this file was going into no longer exists. Upload it somewhere else.',
            rateLimited: 'Too many requests at once. Retry in a moment.',
            creditsExhausted: 'Your organization\'s credit is spent, or does not cover this file\'s first month of storage, charged when it arrives. Top up your credit: the upload starts again afterwards.',
            budgetExceeded: 'A spending limit set on your organization stops this upload. Whoever manages billing can raise it.',
            session: 'The upload expired or was interrupted on the server. Start it again from the beginning.',
            timedOut: 'The server stopped waiting before the upload was over: the connection or the server was too slow. Retry in a moment.',
            server: 'Our server could not receive the file. Retry in a moment; if it keeps failing, contact support.',
        },
    },
    processingFailure: {
        truncated: 'Incomplete file: it stops before its end, probably an interrupted export or copy. Export it again, then re-import it.',
        unreadable: 'Unreadable file: it is damaged, or in a format we do not support. An MP4 (H.264) or an MP3 always works.',
        noPicture: 'No picture in this video file. If it is a sound, import it as an audio file.',
        noSound: 'No sound track in this audio file.',
        quarantined: 'File blocked by the security scan: it cannot be processed.',
        timeout: 'Processing stopped, it was taking too long. A shorter or lighter file will go through.',
        transfer: 'The link could not be downloaded: it must be public and still valid.',
        sourceUnavailable: 'The problem is on our side, not with your file: we could not read it back from our storage. Support can restart the processing, given the media\'s name.',
        internal: 'An error on our side stopped the processing. Support can restart it, given the media\'s name.',
        unknown: 'Processing failed. A new import often fixes it; otherwise, support can help.',
    },
    collection: {
        createTitle: 'Create collection',
        name: 'Collection name',
        selectionHint: '{count} selected item will be added to this collection | {count} selected items will be added to this collection',
        selectType: 'Collection type',
        types: {
            videos: 'Videos',
            audios: 'Audios',
            images: 'Images',
            documents: 'Documents',
        },
        createSuccess: 'Collection created',
        createError: 'Failed to create collection',
    },
    sort: {
        title: 'Sort',
        relevance: 'Relevance',
        nameAsc: 'Name (A → Z)',
        nameDesc: 'Name (Z → A)',
        createdDesc: 'Date added (newest first)',
        createdAsc: 'Date added (oldest first)',
    },
    search: 'Search assets...',
    searchBar: {
        recent: 'Recent',
        saveSearch: 'Save search',
        searchName: 'Search name',
        emptyHint: 'Type to search your assets',
        toSearch: 'to search',
        toClose: 'to close',
        filtersOnly: 'Filters only',
        filtersCount: '{count} filter(s)',
        currentSearch: 'Current search',
        includedFilters: 'Included filters',
        hideFolders: 'Hide folders',
        resetSearch: 'Reset',
    },
    searchResultsBar: {
        resultCount: '{count} result | {count} results',
        searching: 'Searching...',
        clearAll: 'Clear all',
    },
    breadcrumb: {
        folderCount: '{count} folder | {count} folders',
        fileCount: '{count} file | {count} files',
    },
    filters: 'Filters',
    viewGrid: 'Grid view',
    viewList: 'List view',
    settings: {
        title: 'Display settings',
        subtitle: 'Customize how assets are displayed',
        options: 'Options',
        appearance: 'Appearance',
        thumbnails: 'Thumbnails',
        organization: 'Organization',
        viewMode: 'View mode',
        grid: 'Grid',
        list: 'List',
        density: 'Density',
        compact: 'Compact',
        comfortable: 'Comfortable',
        spacious: 'Spacious',
        thumbnailFormat: 'Thumbnail format',
        landscape: 'Landscape',
        square: 'Square',
        portrait: 'Portrait',
        thumbnailFit: 'Thumbnail fit',
        cover: 'Fill',
        contain: 'Fit',
        foldersDisplay: 'Folders display',
        flattenFolders: 'Flatten folders',
        flattenFoldersHint: 'Show all files without folder hierarchy',
        displayedInfo: 'Displayed information',
        default: 'Default',
        custom: 'Custom',
        defaultFieldsInclude: 'Default fields include:',
        fields: {
            type: 'Type',
            duration: 'Duration',
            size: 'Size',
            createdDate: 'Created date',
            owner: 'Owner',
            tags: 'Tags',
            dimensions: 'Dimensions',
            shareLink: 'Share link',
        },
    },
    filter: {
        title: 'Filters',
        subtitle: 'Filter assets by criteria',
        fileType: 'File type',
        fileTypes: 'File types',
        video: 'Video',
        image: 'Image',
        audio: 'Audio',
        document: 'Document',
        archive: 'Archive',
        collections: 'Collections',
        includeCollections: 'Include associated collections',
        status: 'Status',
        statusCreated: 'Created',
        statusProcessing: 'Processing',
        statusReady: 'Ready',
        statusError: 'Error',
        statusArchived: 'Archived',
        visibility: 'Visibility',
        visibleOnly: 'Visible only',
        sensitiveOnly: 'Sensitive content only',
        tags: 'Tags',
        selectTags: 'Select tags',
        workspaces: 'Workspaces',
        selectWorkspaces: 'Select workspaces',
        workspacesCount: '{count} workspace | {count} workspaces',
        clearAll: 'Clear all',
        collectionType: 'Collection type',
        collectionTypes: {
            videos: 'Videos',
            audios: 'Audios',
            images: 'Images',
            documents: 'Documents',
        },
        customMetadata: 'Custom metadata',
        subtitles: 'Subtitles',
        anySubtitles: 'Any',
        withSubtitles: 'With subtitles',
        withoutSubtitles: 'Without subtitles',
        reset: 'Reset',
        saveFilters: 'Save',
        activeCount: '{count} active filter(s)',
        noActiveFilters: 'No active filters',
        favorites: 'Saved searches',
    },
    savedSearch: {
        title: 'Saved searches',
        subtitle: 'Quick access to your saved searches',
        count: '{count} saved search(es)',
        list: 'Your saved searches',
        listDescription: 'Click to apply filters',
        empty: 'No saved searches',
        emptyHint: 'Save your current search to access it quickly later',
        emptyAction: 'Click the star in the search bar',
        untitled: 'Untitled search',
        rename: 'Rename search',
        newName: 'New name',
        filtersCount: '{count} filter | {count} filters',
        noFilters: 'No filters',
        searchQuery: 'Search: {query}',
        resultCount: '{count} result | {count} results',
        saveSuccess: 'Search saved',
        saveError: 'Failed to save search',
        renameSuccess: 'Search renamed',
        renameError: 'Failed to rename search',
        deleteConfirm: 'Are you sure you want to delete this saved search?',
        deleteSuccess: 'Search deleted',
        deleteError: 'Failed to delete search',
        duplicateName: 'A saved search with this name already exists',
    },
    loadMore: '{loaded} of {total}',
    new: 'New',
    newDisabledTooltip: 'Select a workspace to create new items',
    selected: 'selected',
    menu: {
      createClip: 'Create a clip',
        open: 'Open',
        openInNewTab: 'Open in new tab',
        notAllowed: 'Your role does not allow it',
        rename: 'Rename',
        move: 'Move',
        share: 'Share',
        download: 'Download',
        delete: 'Delete',
        copyFrom: 'Import info from another asset',
    },
    permissions: {
        editRequired: "You don't have permission to edit this asset",
        subtitleEditRequired: "You don't have permission to edit this asset's subtitles",
        subtitleDeleteRequired: "You don't have permission to delete this asset's subtitles",
        deleteRequired: "You don't have permission to delete this asset",
        trashRequired: "You don't have permission to trash this asset",
        createRequired: "You don't have permission to create assets",
        moderateRequired: "You don't have permission to moderate assets",
        exportRequired: "You don't have permission to export asset data",
        analyticsRequired: "You don't have permission to view analytics",
    },
    copyFrom: {
        dialogTitle: 'Import info from another asset',
        fields: {
            title: 'Title',
            description: 'Description',
            tags: 'Tags',
            metadata: 'Metadata',
        },
        noValue: 'No value in source',
        newTags: '{count} new tag will be added | {count} new tags will be added',
        sourceTagsCount: '{count} tag in source | {count} tags in source',
        noNewTags: 'All tags already present',
        tagsMode: {
            add: 'Add to existing tags',
            replace: 'Replace existing tags',
        },
        metadataCount: '{count} field will be updated | {count} fields will be updated',
        noMetadata: 'No matching metadata fields',
        apply: 'Apply',
        applied: 'Information copied successfully',
        metadataApplied: 'Metadata updated',
        tooLongSkipped: 'This field is too long to be copied: {fields} | These fields are too long to be copied: {fields}',
        metadataError: 'Failed to update metadata',
        fetchError: 'Failed to load source asset',
    },
    delete: {
        title: 'Delete',
        message: 'This item will be moved to trash. You can restore it for 30 days; it stays billed until it is deleted for good, automatically after 30 days.',
        folderMessage: 'This folder and all its contents will be moved to trash. You can restore them for 30 days; they stay billed until they are deleted for good, automatically after 30 days.',
        bulkMessage: 'These items will be moved to trash. You can restore them for 30 days; they stay billed until they are deleted for good, automatically after 30 days.',
        bulkMessageWithFolders: 'These items (including folders and their contents) will be moved to trash. You can restore them for 30 days; they stay billed until they are deleted for good, automatically after 30 days.',
        allWorkspacesNote: 'Items will be deleted from their respective workspaces.',
        multipleItems: '{count} items',
        publishedOnTitle: 'This media is published on 1 channel | This media is published on {count} channels',
        bulkPublishedOnTitle: 'This selection is published on 1 channel | This selection is published on {count} channels',
        publishedOnEffect: 'Deleting it will make it invisible there.',
        bulkPublishedOnEffect: 'Deleting them will make them invisible there.',
        publishedOnMore: 'and 1 more channel | and {count} more channels',
        publishedOnRecovery: 'The content goes back to draft: it disappears from the public site, but comments and purchases are kept. You can publish it again by hand once you restore the media from the trash, within 30 days.',
        usagesUnavailable: 'We could not check where this media is published. You can go ahead, but we cannot tell you what will be taken down.',
        success: 'Item deleted',
        successMultiple: '{count} items deleted',
        partialSuccess: '{deleted} deleted, {failed} failed',
        error: 'Failed to delete',
    },
    addToChannel: {
        title: 'Add to channel',
        menuLabel: 'Add to channel',
        description: 'Pick the channel to publish this content on.',
        selectChannel: 'Select a channel',
        noChannels: 'No channel available',
        channelsError: 'Could not load the channels.',
        next: 'Next',
        back: 'Back',
        publish: 'Publish',
        success: 'Published on the channel | {count} item published on the channel | {count} items published on the channel',
        error: 'Publishing on the channel failed',
        partialSuccess: '{success} item(s) published — {failed} failed',
        scheduleTitle: 'Schedule the publication',
        scheduleDateLabel: 'Publication date',
        scheduleBtn: 'Schedule',
        showPreview: 'Preview before publication',
        showPreviewHint: 'Show a preview even before the publication date.',
        alreadyPublishedIn: 'This media is already published in:',
        alreadyAdded: 'Already added',
        partiallyAdded: '{done}/{total} already added',
        viewItem: 'View on the channel',
        accessDescription: 'Who will reach this content on the channel.',
        access: {
            public: {
                label: 'Public',
                hint: 'Anybody, with no account.',
            },
            authenticated: {
                label: 'Signed-in visitors',
                hint: 'Anybody who has passed the channel\'s door.',
            },
            restricted: {
                label: 'Restricted',
                hint: 'Only the members the channel opened it to.',
            },
        },
        isListed: 'Listed in the catalogue',
        isListedHint: 'Appears in the channel\'s browse pages.',
        isShownLocked: 'Show locked',
        isShownLockedHint: 'The page stays visible, without playback, to whoever may not reach it.',
        requiresAccessRequest: 'On request',
        requiresAccessRequestHint: 'A member has to ask for access; the content shows itself locked.',
        sale: {
            description: 'How this publication is sold on the channel. Prices are entered including tax, as the buyer pays them.',
            sell: 'Sell this publication',
            sellHint: 'It is reserved to subscribers and buyers, and shown locked to everyone else.',
            exclTax: 'excl. tax',
            priceExclTax: 'Price excl. tax',
            priceInclTax: 'Public price incl. tax',
            inclTax: 'incl. tax',
            breakdown: 'That is {net} excl. tax + {vat} VAT ({rate}), at the French rate.',
            priceMinimum: 'The minimum price is {amount} incl. tax',
            estimate: 'About {amount} incl. tax for a viewer in France ({rate} VAT, an estimate: the exact tax is computed at payment).',
            noVat: 'VAT not applicable: the viewer pays this price.',
            invalid: 'Choose at least one subscription or one price, and a price of at least €2 incl. tax for each mode switched on.',
            accessNote: 'A sold publication is restricted: the access chosen at the previous step is replaced.',
            plans: {
                title: 'Included in subscriptions',
                every: 'In every subscription of the channel',
                none: 'This channel has no subscription to choose yet.',
                fullAccess: 'Already included in the subscriptions that open the whole catalogue: {plans}.',
            },
            purchase: {
                title: 'Single purchase',
                name: 'Buy',
            },
            rental: {
                title: 'Rental',
                name: 'Rent for {duration}',
                duration: 'Duration',
                units: {
                    hour: 'Hours',
                    day: 'Days',
                    month: 'Months',
                    year: 'Years',
                },
                counted: {
                    hour: '{count} hour',
                    hours: '{count} hours',
                    day: '{count} day',
                    days: '{count} days',
                    month: '{count} month',
                    months: '{count} months',
                    year: '{count} year',
                    years: '{count} years',
                },
            },
        },
        categoriesDescription: 'File the publication in the channel\'s catalogue.',
        categories: 'Categories',
        noCategories: 'This channel has no category',
        primaryCategory: 'Main category',
        steps: {
            channel: 'Channel',
            visibility: 'Access',
            sale: 'Sale',
            categories: 'Categories',
        },
        processing: {
            creating: 'Creating the publications...',
            configuring: 'Applying the settings...',
            pricing: 'Setting the prices...',
            publishing: 'Putting them out...',
        },
        skipped: {
            absent: 'One media could not be found | {count} media could not be found',
            not_ready: 'One media is not ready yet | {count} media are not ready yet',
            wrong_type: 'One media is not of a kind a channel publishes | {count} media are not of a kind a channel publishes',
            already_published: 'One media is already published on this channel | {count} media are already published on this channel',
            mixed: 'One media could not be published | {count} media could not be published',
        },
    },
    listViewComingSoon: 'List view coming soon',
    createFolder: 'Create folder',
    createFolderDescription: 'Organize your files',
    createCollection: 'Create collection',
    createCollectionDescription: 'Group your media',
    uploadFile: 'Upload files',
    uploadFileDescription: 'Add your media',
    empty: {
        title: 'This space is empty',
        titleFolder: 'This folder is empty',
        description: 'Start by organizing your files, creating folders or collections',
        descriptionFolder: 'Add files or create subfolders to organize your content',
        noResults: 'No results found',
        noResultsDescription: 'Try adjusting your filters or search to find what you are looking for',
        recentTitle: 'Nothing new in the last {days} days',
        recentDescription: 'Media added to this workspace show here for {days} days.',
        recentDescriptionAll: 'Media added to your workspaces show here for {days} days.',
        uploadTitle: 'Upload files',
        uploadDescription: 'Add your media',
        folderTitle: 'Create folder',
        folderDescription: 'Organize your files',
        collectionTitle: 'Create collection',
        collectionDescription: 'Group your media',
        dragHint: 'You can also drag and drop files anywhere on this page',
        readOnly: 'You are viewing this workspace read-only. To add files to it, ask one of its administrators.',
        clearFilters: 'Clear filters',
    },
    rename: {
        title: 'Rename',
        newName: 'New name',
        success: 'Renamed successfully',
        error: 'Failed to rename',
    },
    download: {
        error: 'Failed to download file',
        noDownloadable: 'No downloadable files in selection',
        foldersSkipped: '{count} folder(s) skipped — not downloadable',
        toast: {
            itemsLabel: '{count} items',
            buildingDetail: '{processed} / {total} file(s) compressed',
            readyDetail: '{count} file(s) — {filename}',
        },
    },
    bulkMenu: {
        subheader: '{count} item(s) selected',
        groupIntoFolder: 'Group',
        groupSuccess: '{count} item moved into "{name}" | {count} items moved into "{name}"',
        createCollection: 'Create collection',
        createCollectionSuccess: '{count} item added to "{name}" | {count} items added to "{name}"',
        createCollectionError: 'Failed to add items to the collection',
    },
    preview: {
        title: 'Preview',
        loadError: 'Failed to load preview',
        notAvailable: 'Preview not available for this file type',
        openDetails: 'Open details',
    },
    move: {
        title: 'Move',
        subtitle: 'Select the destination folder',
        selectDestination: 'Select destination folder',
        itemCount: '{count} item(s) to move',
        moving: 'Items to move',
        more: 'more',
        searchPlaceholder: 'Search folders...',
        destination: 'Destination',
        cannotMoveHere: 'Invalid destination',
        action: 'Move',
        success: '{count} item(s) moved',
        successSingle: 'Item moved successfully',
        successMultiple: '{count} items moved successfully',
        error: 'Error moving items',
        errorSameFolder: 'Cannot move a folder into itself',
        rootFolder: 'Root',
    },
    createNew: {
        uploadFiles: 'Upload files',
        targetWorkspace: 'Workspace',
        targetWorkspaceHint: 'Select where to create',
        workspaceRequired: 'Select a workspace',
        title: 'New',
        dropzoneTitle: 'Drop your files here',
        dropzoneSubtitle: 'or click to browse',
        createSection: 'Create',
        folder: 'Folder',
        folderDescription: 'Organize your files',
        collection: 'Collection',
        collectionDescription: 'Group your media',
        note: 'Note',
        noteDescription: 'Document your projects',
        thirdParty: 'External video',
        thirdPartyDescription: 'YouTube, Vimeo, Dailymotion',
        importSection: 'Import from',
        importFromService: 'Import your files',
        uploadBanner: {
            uploading: '{count} upload(s) in progress...',
            completed: 'Uploads completed',
            moreDetails: 'More details',
        },
    },
    importThirdParty: {
        title: 'Import external video',
        urlLabel: 'Video link or embed code',
        urlPlaceholder: 'Paste a YouTube, Vimeo or Dailymotion link, or the embed code from another site...',
        urlHint: 'Other sites work too: copy the embed code they give you and paste it here.',
        submit: 'Import',
        errorGeneric: 'Failed to import the video. Please check the URL and try again.',
        preview: 'Preview',
        previewLoading: 'Fetching video info...',
        previewError: 'Unable to fetch video information. Please check the URL and try again.',
        nameLabel: 'Name',
        namePlaceholder: 'Enter a name for this asset...',
        confirmImport: 'Import this video',
        changeUrl: 'Change URL',
    },
    subtitles: {
        status: {
            processing: 'Processing...',
            processingPercent: 'Processing… {percent}%',
            failed: 'Error',
        },
        generation: {
            completed: 'Subtitles generated successfully',
            failed: 'Failed to generate subtitles',
        },
        hero: {
            title: 'Subtitles',
            description: 'Manage subtitles for your video',
            features: {
                accuracy: '95%+ accuracy',
                languages: '50+ languages',
                punctuation: 'Auto punctuation',
            },
            import: 'Import a .srt/.vtt file',
            pending: {
                title: 'Speech analysis required',
                description: 'This media has not been analyzed for speech yet. Run the analysis to enable automatic subtitle generation.',
                trigger: 'Analyze',
            },
            analyzing: {
                title: 'Analysis in progress',
                description: 'We are analyzing your video to detect speech. This may take a few minutes.',
            },
            failed: {
                title: 'Analysis failed',
                description: 'Speech analysis failed for this media. You can retry the analysis.',
                retry: 'Retry',
            },
            noSpeech: {
                title: 'No speech detected',
                description: 'This video does not contain any speech, so automatic subtitles cannot be generated.',
            },
        },
        error: {
            title: 'Failed to load subtitles',
            description: 'An error occurred while loading the subtitles. Please try again.',
            retry: 'Retry',
        },
        list: {
            title: 'Subtitles',
            countNone: 'None',
            countOne: '1 subtitle',
            countMultiple: '{count} subtitles',
            importAction: 'Import .srt / .vtt',
            generateAction: 'Generate with Scribe',
            columns: {
                track: 'Track',
                atStart: 'At start',
                inMenu: 'In the CC menu',
                origin: 'Origin',
            },
            atStartLabel: 'Show {name} at start',
            atStartYes: 'Yes',
            atStartSet: 'Show these subtitles from the start of the video',
            atStartClear: 'Stop showing them at start',
            atStartPlanned: 'Planned',
            atStartHidden: 'A hidden track cannot show at start: offer it in the CC menu first',
            offered: 'Offered',
            hidden: 'Hidden',
            inMenuLabel: 'Offer {name} in the CC menu',
            offeredWhenReady: 'Once ready',
            origin: {
                imported: 'Imported',
                generated: 'Generated by Scribe',
                translated: 'Translated by AI',
            },
            rule: 'Only one track can show at start. A hidden track cannot.',
            autoGeneratedHint: 'Show the "auto-generated" mention in the player',
            labelPlaceholder: 'Subtitle name',
            actions: {
                edit: 'Edit',
                download: 'Download',
                delete: 'Delete',
                retry: 'Retry',
            },
        },
        viewer: {
            eyebrow: 'What the viewer sees',
            noTrack: 'This video has no subtitles yet.',
            noButton: 'The CC button does not appear in the player until a track is added.',
            startsWith: '{name} subtitles show from the start of the video.',
            willStartWith: 'Generating: {name} subtitles will show from the start of the video once they are ready.',
            firstReadyWillStart: 'Generating: the first subtitles ready will show from the start of the video.',
            startsWithNone: 'No subtitles show at start.',
            scope: 'On shares, the channel and direct links; in an embed, only when its "Auto-display subtitles" option is on.',
            menu: 'Viewers can also pick from the player\'s {cc} menu: {names}.',
            meanwhile: 'Nothing changes for viewers until then. You can leave this page.',
            noMenu: 'The {cc} button does not appear in the player: no subtitles are offered.',
            soon: '{name} subtitles coming here',
            soonFirst: 'Subtitles coming here',
            clearDefault: 'Show nothing at start',
            hint: 'Set each track in the list below.',
            firstWillStart: 'Once they are ready, the subtitles will show at start on shares, embeds, the channel and direct links.',
            nowDefault: '{name} subtitles are ready. They now show at start on shares, embeds, the channel and direct links.',
            undoDefault: 'Don\'t show them at start',
        },
        start: {
            generate: {
                title: 'Generate with Scribe',
                description: 'Automatic transcription of the video, then translation into other languages if you wish.',
                action: 'Generate subtitles',
            },
            firstIsDefault: 'The first subtitles ready will show at start on shares, embeds, the channel and direct links. You can change this afterwards.',
            import: {
                title: 'Import a file',
                description: 'Already have subtitles? Import a .srt or .vtt file and choose its language.',
                action: 'Choose a file',
            },
        },
        generateModal: {
            title: 'Generate subtitles',
            description: 'Scribe will automatically transcribe your video with AI',
            language: 'Subtitle language',
            duration: 'Video duration',
            costPerMinute: 'Cost per minute',
            totalCost: 'Total cost',
            credits: 'credits',
            cancel: 'Cancel',
            generate: 'Generate',
        },
        importModal: {
            title: 'Import subtitles',
            description: 'Select the language of the subtitle file you are importing.',
            language: 'Subtitle language',
            cancel: 'Cancel',
            import: 'Import',
        },
    },
    chapters: {
        hero: {
            title: 'Chapters',
            description: 'Add chapters to help viewers navigate your video',
            add: 'Add chapter',
            importClipboard: 'Import from clipboard',
        },
        banner: {
            title: 'Add chapters to your video',
            description: 'Help your viewers navigate by marking key moments. Add chapters manually or import a list from your clipboard.',
            pending: {
                title: 'Speech analysis required',
                description: 'This media has not been analyzed for speech yet. Run the analysis to enable AI chapter generation.',
                trigger: 'Analyze',
            },
            analyzing: {
                title: 'Analysis in progress',
                description: 'We are analyzing your media to detect speech. This may take a few minutes.',
            },
            failed: {
                title: 'Analysis failed',
                description: 'Speech analysis failed for this media. You can retry the analysis.',
                retry: 'Retry',
            },
            noSpeech: {
                title: 'No speech detected',
                description: 'This media does not contain any speech, so automatic chapter generation is not available.',
            },
            ready: {
                title: 'AI chapter generation',
                description: 'Automatically generate chapters from the transcription using AI.',
            },
            generate: 'Generate',
        },
        generateModal: {
            title: 'Generate chapters',
            generating: 'Generating chapters...',
            generatingDescription: 'AI is analyzing the transcription to identify chapters.',
            preview: 'Generated chapters',
            previewDescription: 'Review the chapters below before importing.',
            replace: 'Replace all',
            append: 'Add to existing',
            error: 'Generation failed',
            errorDescription: 'An error occurred while generating chapters. Please try again.',
            retry: 'Retry',
            count: '{count} chapters generated',
        },
        importConfirm: {
            title: 'Import chapters',
            message: '{count} chapters found in clipboard. You already have existing chapters.',
            replace: 'Replace all',
            append: 'Add to existing',
        },
        list: {
            title: 'Chapters',
            countNone: 'None',
            countOne: '1 chapter',
            countMultiple: '{count} chapters',
            emptyTitle: 'No chapters yet',
            emptyDescription: 'Add your first chapter to get started',
            namePlaceholder: 'Chapter name',
            importHint: 'You can import multiple chapters at once. Prepare your list in a text editor or spreadsheet using the format below, copy it, then click "Import from clipboard".',
            importFormat: 'Expected format: one chapter per line',
            importExample: '00:00:00 - Introduction\n00:02:30 - First topic\n00:15:00 - Conclusion',
            actions: {
                delete: 'Delete',
            },
        },
        error: {
            title: 'Failed to load chapters',
            description: 'An error occurred while loading the chapters. Please try again.',
            retry: 'Retry',
        },
        unsavedChanges: 'You have unsaved changes',
        saveSuccess: 'Chapters saved successfully',
        saveError: 'Failed to save chapters',
    },
    interactivity: {
        title: 'Interactions',
        description: 'Display calls to action, rating prompts and more directly in the player, at any moment during playback.',
        workspaceDescription: 'Display calls to action, rating prompts and more directly in the video player. Interactions defined here are automatically applied to all assets in this workspace.',
        organizationDescription: 'Display calls to action, rating prompts and more directly in the video player. Interactions defined here are automatically applied to all assets across the organization.',
        addInteraction: 'Add',
        inheritedInfo: 'Interactions inherited from the organization or workspace level are also active on this asset.',
        saved: 'Interaction created',
        updated: 'Interaction updated',
        deleted: 'Interaction deleted',
        saveError: 'Failed to save changes',
        recommendations: {
            description: 'Offer other videos when this one ends, in the embedded player and on share pages.',
            heading: 'Heading',
            headingPlaceholder: 'Up next',
            empty: {
                title: 'No recommended videos',
                description: 'Add up to 8 videos to offer when this one ends.',
            },
            previewEmpty: 'Add videos to see the end screen.',
            notReady: 'Not ready yet',
            moveUp: 'Move up',
            moveDown: 'Move down',
            remove: 'Remove',
            unsavedChanges: 'You have unsaved changes',
            saveSuccess: 'Recommendations saved',
            saveError: 'Failed to save the recommendations',
        },
        cards: {
            configure: 'Configure',
            close: 'Close',
            ctaNone: 'No call to action',
            ctaOff: 'Turned off',
            ctaActive: '{n} active | {n} active',
            inherited: '{n} inherited | {n} inherited',
            ctaSwitchHint: 'Add a call to action to turn it on',
            ratingNone: 'Not created yet',
            ratingOff: 'Turned off',
            ratingOn: 'On · {when}',
            recoNone: 'No videos',
            recoCount: '{n} video | {n} videos',
            toggledOn: 'Turned on',
            toggledOff: 'Turned off',
        },
        panel: {
            ctaTitle: 'Calls to action',
            ctaOff: 'This video\'s calls to action are turned off: viewers see none of them.',
            ratingOff: 'The rating is turned off: viewers do not see it.',
            enable: 'Turn on',
            addCta: 'Add a call to action',
            newCta: 'New call to action',
            unsaved: 'Not saved',
            inactive: 'Off',
            untitled: 'Untitled',
            deleteCta: 'Delete this call to action',
            emptyCta: {
                title: 'No call to action on this video',
                description: 'Add a button that takes your viewers wherever you want, at the moment you choose.',
            },
            inheritedFromWorkspace: 'Inherited from the workspace',
            inheritedFromOrganization: 'Inherited from the organization',
            rating: {
                // The player shows one rating per video, the narrowest scope's: these say which.
                replacesInherited: {
                    workspace: 'This rating replaces the workspace’s.',
                    organization: 'This rating replaces the organization’s.',
                },
                inheritedShown: {
                    workspace: 'The workspace’s rating is shown here: turning one on replaces it.',
                    organization: 'The organization’s rating is shown here: turning one on replaces it.',
                },
            },
            readOnlyWorkspace: 'Only someone who manages this workspace can change its interactions.',
            readOnlyOrganization: 'Only someone who manages the organization\'s settings can change its interactions.',
            editInWorkspace: 'Edit in the workspace',
            overlapWarning: 'Same place and same moment as “{name}”: the two will overlap.',
            ctaInvalid: 'Add a message or a whole button: its text and its link.',
            ratingInvalid: 'Fill in the question.',
            unsavedChanges: 'You have unsaved changes',
            saveSuccess: 'Changes saved',
            saveError: 'Saving failed',
            discard: {
                title: 'Discard your changes?',
                message: 'Unsaved changes will be lost.',
                confirm: 'Discard',
                cancel: 'Keep editing',
            },
        },
        timeline: {
            title: 'Across the video',
            onPause: '{n} on pause | {n} on pause',
        },
        types: {
            cta: 'Call to Action',
            ctaDescription: 'Add a clickable button to your video',
            rating: 'Rating',
            ratingDescription: 'Collect feedback from your viewers',
            recommendations: 'Recommendations',
        },
        triggers: {
            atMoment: 'At a moment',
            atShare: 'At a percentage',
            atTimecode: 'At {time}',
            atPercentValue: 'At {percent}%',
            atTime: 'At',
            atPercent: 'At',
            videoStart: 'Video start',
            videoEnd: 'Video end',
            onPause: 'On pause',
        },
        positions: {
            center: 'Center',
            topLeft: 'Top left',
            topCenter: 'Top center',
            topRight: 'Top right',
            bottomLeft: 'Bottom left',
            bottomCenter: 'Bottom center',
            bottomRight: 'Bottom right',
            fullscreen: 'Fullscreen',
        },
        animations: {
            fade: 'Fade',
            slideUp: 'Slide up',
            slideDown: 'Slide down',
            scale: 'Scale',
            none: 'None',
        },
        form: {
            when: 'When',
            where: 'Where',
            moreOptions: 'More options',
            triggerTimecode: 'Moment (min:s)',
            ofDuration: 'of {duration}',
            back: 'Back',
            captions: {
                start: 'Shown as soon as playback starts.',
                time: 'Shown at {time}.',
                percent: 'Shown at {percent}% of the video.',
                end: 'Shown when the video ends.',
                pause: 'Shown when the viewer pauses the video.',
            },
            createTitle: 'New interaction',
            editTitle: 'Edit interaction',
            trigger: 'Trigger',
            triggerTime: 'Time (seconds)',
            triggerPercent: 'Percentage watched',
            content: 'Content',
            ctaText: 'Text',
            ctaButtonText: 'Button text',
            ctaTextDefault: 'Find out more on our website.',
            ctaButtonTextOptional: 'Button text (optional)',
            ctaUrlOptional: 'Button link (optional)',
            ctaButtonLabelMissing: 'Give the button a text, or clear its link to show the message alone.',
            ctaButtonLinkMissing: 'Add the button\'s link, or clear its text to show the message alone.',
            ctaTextOnly: 'With no button, the call to action shows its message alone.',
            ctaButtonTextDefault: 'Learn more',
            ctaUrl: 'Button URL',
            ctaButtonVariant: 'Button style',
            ctaButtonVariantFilled: 'Filled',
            ctaButtonVariantTonal: 'Tonal',
            ctaButtonVariantOutlined: 'Outlined',
            ctaButtonVariantText: 'Text link',
            ctaButtonColor: 'Button color',
            ratingQuestion: 'Question',
            ratingQuestionDefault: 'How would you rate this video?',
            enableComment: 'Allow text comment',
            commentPlaceholder: 'Add a comment...',
            preview: 'Preview',
            position: 'Position',
            display: 'Display',
            animation: 'Animation',
            autoHide: 'Auto-hide after (seconds)',
            autoHidePlaceholder: 'Never',
            dismissible: 'Dismissible',
            showOnce: 'Show only once per session',
            pausesVideo: 'Pause video when displayed',
            showMarker: 'Show marker on progress bar',
            previewTrigger: 'Preview',
            required: 'This field is required',
            recommendedVideos: 'Recommended videos',
            addVideos: 'Add videos',
            maxVideos: 'Maximum {n} videos',
            recommendationsInfo: 'Recommendations are displayed fullscreen at the end of the video.',
            cancel: 'Cancel',
            create: 'Create',
            save: 'Save',
        },
        empty: {
            title: 'No interactions yet',
            description: 'Add interactions like CTAs or rating prompts to your embeds.',
            workspaceDescription: 'Add calls to action, rating prompts and more to display in the video player for all assets in this workspace.',
            organizationDescription: 'Add calls to action, rating prompts and more to display in the video player for all assets across the organization.',
        },
        error: {
            title: 'Failed to load interactions',
            description: 'An error occurred while loading interactions.',
            retry: 'Retry',
        },
        deleteConfirm: {
            title: 'Delete interaction',
            message: 'Are you sure you want to delete this interaction? This action cannot be undone.',
            confirm: 'Delete',
        },
    },
    aiWriting: {
        title: 'AI Writing',
        subtitle: 'Generate content from your transcription using AI',
        types: {
            titles: 'Titles',
            titlesDesc: 'Generate compelling titles for your content',
            description: 'Description',
            descriptionDesc: 'Generate short descriptions (2-3 sentences)',
            summary: 'Summary',
            summaryDesc: 'Generate detailed summaries (4-6 sentences)',
            seoKeywords: 'SEO Keywords',
            seoKeywordsDesc: 'Generate relevant SEO keyword lists',
        },
        form: {
            language: 'Language',
            languageSpoken: 'Language of the video',
            tone: 'Tone',
            context: 'Additional context',
            contextPlaceholder: 'Add specific instructions or context to guide the AI...',
            generate: 'Generate',
        },
        tones: {
            professional: 'Professional',
            casual: 'Casual',
            formal: 'Formal',
            creative: 'Creative',
        },
        results: {
            title: 'Suggestions',
            emptyTitle: 'No suggestions yet',
            emptyDescription: 'Configure your options and click Generate to get AI-powered suggestions.',
            generating: 'Generating suggestions...',
            generatingDescription: 'AI is analyzing the transcription to generate content.',
            error: 'Generation failed',
            errorDescription: 'An error occurred while generating content. Please try again.',
            retry: 'Retry',
            regenerate: 'Regenerate',
            copy: 'Copy',
            copied: 'Copied to clipboard',
            apply: 'Apply',
            applied: 'Applied',
        },
        applied: 'Content applied successfully',
        tagsAdded: '{count} keyword(s) added as tags',
        tagsAddError: '{count} keyword(s) could not be added as tags',
        tagsRestricted: '{count} keyword(s) skipped: only existing tags can be added',
        unavailable: 'AI Writing unavailable',
        unavailableDescription: 'This feature requires a video or audio with detected speech. Please generate subtitles first.',
        noSpeechDescription: 'No speech was detected in this media, so there is no transcript to write from.',
    },
    aiWritingV2: {
        generateAll: 'Generate All',
        addContext: 'Add context',
        summaryHint: 'Summaries are for reference only and cannot be applied directly to a field.',
    },
    files: {
        title: 'Files & Versions',
        description: 'Manage source files and version history',
        download: 'Download',
        sourceDownloadUrl: 'Permanent source file link',
        sourceDownloadUrlHint:
            'PDFs and images open in the browser, other files download. Add ?attachment=true to force a download.',
        copyLink: 'Copy link',
        linkCopied: 'Link copied!',
        copyFailed: 'Failed to copy link',
        versionHistory: 'Version history',
        current: 'Current',
        deleted: 'Deleted',
        purged: 'Deleted for good',
        droppedRetention: 'A deleted version stays restorable and billed for 30 days, then it is deleted for good.',
        countNone: 'No versions',
        countOne: '1 version',
        countMultiple: '{count} versions',
        emptyTitle: 'No versions available',
        emptyDescription: 'Upload a file to create the first version',
        error: {
            title: 'Failed to load versions',
            description: 'An error occurred while loading the version history. Please try again.',
            retry: 'Retry',
        },
        actions: {
            revert: 'Revert to this version',
            delete: 'Delete this version',
            purge: 'Delete for good',
        },
        deleteConfirm: {
            title: 'Delete version',
            message: 'Version {version} — its source file and its renditions — goes to the trash. You can restore it from here for 30 days; it stays billed until it is deleted for good, automatically after 30 days.',
            confirm: 'Move to trash',
            cancel: 'Cancel',
        },
        actionsRestore: 'Restore this version',
        restoreSuccess: 'Version {version} restored',
        restoreError: 'Failed to restore the version',
        purgeConfirm: {
            title: 'Delete the version for good',
            message: 'Version {version} — its source file and its renditions — will be deleted for good and will no longer be billed. This cannot be undone: the version can no longer be restored.',
            confirm: 'Delete for good',
        },
        purgeSuccess: 'Version {version} deleted for good',
        purgeError: 'Could not delete the version for good',
        purgeLocked: 'This item was validated in the pool: only a moderator of the pool can delete this version for good.',
        revertConfirm: {
            title: 'Revert to version',
            message: 'Are you sure you want to revert to version {version}? This will set it as the current version.',
            confirm: 'Revert',
            cancel: 'Cancel',
        },
        deleteSuccess: 'Version {version} moved to the trash',
        deleteError: 'Failed to delete version',
        revertSuccess: 'Reverted to version {version}',
        revertError: 'Failed to revert to version',
        replace: {
            button: 'Replace file',
            confirmTitle: 'Replace file',
            confirmMessage: 'This will create a new version. The current version will be kept in the history.',
            confirmButton: 'Replace',
            error: 'Unable to start the upload. Please try again.',
        },
        processing: {
            title: 'Processing in progress',
            pending: 'Waiting...',
            uploading: 'Uploading...',
            fetchingSource: 'Downloading from the link...',
            extractingMetadata: 'Extracting metadata...',
            extractingText: 'Reading the text...',
            generatingThumbnails: 'Generating previews...',
            drawingWaveform: 'Drawing the waveform...',
            buildingFilmstrip: 'Building the preview strip...',
            encoding: 'Encoding for streaming...',
            completed: 'Completed',
            failed: 'Processing failed',
            failedTitle: 'Processing error',
            failedDescription: 'An error occurred while processing the file. You can try uploading a new file or revert to the previous version.',
            interruptedTitle: 'Upload interrupted',
            interruptedDescription: 'The file never arrived: its upload stopped before the end. Send it again — the media keeps its title, folder and tags.',
            retryUpload: 'Upload new file',
            revertButton: 'Revert to v{version}',
        },
        relationships: {
            title: 'Related Files',
            countNone: 'None',
            countOne: '1 relationship',
            countMultiple: '{count} relationships',
            emptyTitle: 'No related files',
            emptyDescription: 'Link other files to create relationships',
            add: 'Add relationship',
            types: {
                RELATED: 'Related',
                DERIVED_FROM: 'Derived from',
                VERSION_OF: 'Version of',
                PART_OF: 'Part of',
                DUPLICATE_OF: 'Duplicate of',
                ALTERNATIVE_TO: 'Alternative to',
                REFERENCES: 'References',
                REFERENCED_BY: 'Referenced by',
                SUBTITLE_FOR: 'Subtitle for',
            },
            public: 'Public',
            private: 'Private',
            publicTooltip: 'When public, this file is offered for download on this asset\'s share page and in its player',
            inLibrary: 'In library',
            linkedOnly: 'Linked file',
            updateError: 'Failed to update relationship',
            deleteConfirm: {
                title: 'Remove relationship',
                message: 'Are you sure you want to remove this relationship with "{name}"?',
                confirm: 'Remove',
            },
            addModal: {
                title: 'Add Relationship',
                selectAsset: 'Select an asset',
                selectAssetDescription: 'Choose an asset to link with this one',
                typeLabel: 'Relationship type',
            },
            wizard: {
                title: 'Add Relationship',
                source: {
                    subtitle: 'Choose how you want to add the related asset',
                    upload: {
                        title: 'Upload a file',
                        description: 'Upload a new file to link with this asset',
                    },
                    library: {
                        title: 'Select from library',
                        description: 'Choose an existing asset from your library',
                    },
                },
                file: {
                    title: 'File',
                    uploadLabel: 'Drop a file or click to browse',
                    selectedFile: 'Selected file',
                    selectedAsset: 'Selected asset',
                    changeFile: 'Change',
                    selectAsset: 'Select an asset',
                    selectAssets: 'Select assets',
                    addMore: 'Add more',
                    uploadNotice: 'Files will be linked directly to this asset and will not appear in your library.',
                    makePublic: 'Make available for download on the share page and in the player',
                    makePublicHint: 'You can change this later from the linked files list.',
                },
                validation: {
                    selectSource: 'Please select a source type',
                    selectFile: 'Please select or upload a file',
                },
            },
            uploadStarted: 'Upload started — the relationship will be created automatically',
            addSuccess: 'Relationship added',
            addError: 'Failed to add relationship',
            deleteSuccess: 'Relationship removed',
            deleteError: 'Failed to remove relationship',
            lockedOther: 'This link touches an asset validated in the shared pool: only a moderator of the pool can draw or remove it.',
        },
        audioTracks: {
            title: 'Audio tracks',
            countNone: 'Original sound only',
            countOne: '1 track added',
            countMultiple: '{count} tracks added',
            intro: 'Offer the same video in another language or in an adapted version (clearer dialogue, no music…). The picture stays the same: viewers pick the sound from the player\'s Settings › Audio menu.',
            add: 'Add an audio track',
            loadError: 'The audio tracks could not be loaded.',
            empty: {
                title: 'Make this video available in other languages',
                description: 'Add a dub or an adapted version: the picture does not change, viewers pick the sound in the player.',
                steps: {
                    language: { title: 'Choose the language', text: 'and the name viewers see' },
                    file: { title: 'Import the audio file', text: 'as long as the video' },
                    player: { title: 'It reaches the player', text: 'once it has been prepared' },
                },
            },
            original: {
                name: 'Original sound',
                description: 'The video file\'s own sound, always offered in the player',
            },
            footnote: 'MP3, WAV, AAC, M4A or FLAC · 500 MB maximum · the track must be as long as the video.',
            dialog: {
                title: 'Add an audio track',
                intro: 'An audio track replaces the video\'s sound without touching the picture: a dub in another language, a version with clearer dialogue, a version without music… Viewers switch between them from the player.',
                checklist: {
                    duration: 'As long as the video, starting on the same frame.',
                    mix: 'The full mix (voices, music and effects), not the voices alone.',
                    formats: 'MP3, WAV, AAC, M4A or FLAC, 500 MB maximum.',
                },
                language: 'Language',
                languageHint: 'Pick one or type a code (e.g. fr, en, es)',
                languageInvalid: '“{value}” is not a language code. A code is two or three letters, optionally followed by a region: fr, en, pt-BR…',
                name: 'Name in the player',
                nameHint: 'What viewers see in the Audio menu',
                hearingImpaired: 'Version for deaf and hard-of-hearing viewers',
                hearingImpairedHint: 'Clearer dialogue: the player offers it with its own button.',
                defaultLater: 'To have the player start on this track, choose “Set as default” in the list once it is available there.',
                drop: 'Drop an audio file here or click to browse',
                formats: 'MP3, WAV, AAC, M4A, FLAC · 500 MB maximum',
                change: 'Change',
                notAudio: 'This file is not an audio file.',
                tooLarge: 'This file is larger than 500 MB.',
                durationMatches: 'Same length as the video',
                durationLonger: 'This track lasts {track} and the video {video}: it will be cut at the end of the video.',
                durationShorter: 'This track lasts {track} and the video {video}: it will be padded with silence.',
                submit: 'Import the track',
            },
            defaultBadge: 'Default',
            defaultPendingBadge: 'Default once available',
            hearingImpaired: 'Hard of hearing',
            uploaded: 'Added',
            embedded: 'Original file',
            mono: 'Mono',
            channelsN: '{n} channels',
            trackIndex: 'Track {index}',
            unknownTrack: 'Track',
            addedOn: 'added on {date}',
            playback: {
                ready: 'Available in the player',
                preparing: 'Being prepared for the player. This can take a while; you can leave this page.',
                waiting: 'Ready: offered in the player as soon as the video itself has been encoded.',
                failed: 'Preparation failed. Delete the track and import it again.',
                unavailable: 'Not offered in the player yet. Delete the track and import it again.',
                // A language of the video's own file: it has no file to import again.
                source: {
                    failed: 'Preparing this language of the video file failed. To offer it anyway, import it as a separate audio track: an audio file as long as the video.',
                    unavailable: 'This language of the video file is not offered in the player. To offer it, import it as a separate audio track: an audio file as long as the video.',
                },
            },
            leave: {
                title: 'Upload in progress',
                message: 'An audio track is being uploaded. If you leave this page, the upload is cancelled and the file is lost.',
                confirm: 'Leave and cancel the upload',
                stay: 'Stay on the page',
            },
            uploadProgress: 'Uploading {percent}% · {loaded} of {total}. Keep this tab open.',
            uploadProgressEta: 'Uploading {percent}% · {loaded} of {total} · about {eta} left. Keep this tab open.',
            uploadFinishing: 'Upload complete, saving…',
            etaSeconds: '{n} s',
            etaMinutes: '{n} min',
            uploadFailed: 'The upload failed: {reason}',
            uploadFailure: {
                tooLarge: 'the file is larger than 500 MB.',
                notAudio: 'this file is not recognised as an audio file.',
                refused: 'the server refused the file or what was said about it. Check that it is an audio file and that the language is a language code.',
                network: 'the connection was interrupted. Check it, then try again.',
                other: 'the server could not store it. Try again in a moment.',
            },
            dismiss: 'Remove',
            setAsDefault: 'Set as default',
            alreadyDefault: 'Default track',
            cannotSetDefaultUntilReady: 'Possible once the track is available in the player',
            editTooltip: 'Edit the name and language',
            editTitle: 'Edit the audio track',
            download: 'Download',
            delete: 'Delete',
            uploadSuccess: 'Audio track uploaded, being prepared for the player',
            uploadError: 'The audio track could not be uploaded',
            downloadError: 'The download failed',
            updateSuccess: 'Audio track updated',
            updateError: 'The update failed',
            deleteConfirm: 'Delete “{name}” from this video?',
            deleteEmbeddedConfirm: 'Remove “{name}” from the player? This language comes from the video file: once removed, it cannot be brought back — only an audio track imported separately can take its place. The video file itself is not changed.',
            deleteConfirmButton: 'Delete',
            deleteSuccess: 'Audio track deleted',
            deleteError: 'The deletion failed',
        },
        collection: {
            mode: {
                description: 'Choose how items are added to this collection',
                onboarding: {
                    title: 'How do you want to build this collection?',
                    description: 'Choose a mode to determine how items are added. You can change this at any time.',
                },
                curated: {
                    title: 'Manual',
                    label: 'Manual',
                    description: 'Select and order items manually',
                    cardDescription: 'Hand-pick each item and arrange them exactly the way you want.',
                    features: {
                        pick: 'Choose items from your library',
                        order: 'Drag & drop to reorder freely',
                        control: 'Full control over your content',
                    },
                },
                smart: {
                    title: 'Smart',
                    label: 'Smart',
                    description: 'Auto-populate based on rules',
                    cardDescription: 'Define rules and let the collection populate itself automatically.',
                    features: {
                        rules: 'Filter by type, tags, and more',
                        auto: 'Updates automatically with new content',
                        time: 'Ideal for large, evolving collections',
                    },
                },
                change: 'Change mode',
                switchTitle: 'Change mode',
                switchToSmartWarning: 'Switching to smart mode will replace your manually added items with automatically selected ones. Continue?',
                switchToCuratedConfirm: 'Do you want to keep the current items when switching to manual mode?',
                changed: 'Collection mode changed',
                changeFailed: 'Failed to change mode',
            },
            contents: {
                hero: {
                    title: 'Contents',
                    description: 'Manage items in this collection',
                },
                error: {
                    title: 'Failed to load contents',
                    description: 'There was a problem loading the collection contents.',
                    retry: 'Try again',
                },
                title: 'Items',
                itemCount: {
                    zero: 'No items',
                    one: '1 item',
                    other: '{count} items',
                },
                addItems: 'Add items',
                selectItems: 'Select items to add',
                addFirstItem: 'Add first item',
                emptyTitle: 'No items yet',
                emptyDescription: 'Add items to start building your collection',
                noNewItems: 'All selected items are already in the collection',
                itemsAdded: 'Items added to collection',
                addFailed: 'Failed to add items',
                itemRemoved: 'Item removed',
                removeFailed: 'Failed to remove item',
                reorderFailed: 'Failed to reorder items',
                orderByChanged: 'Sorting updated',
                orderByChangeFailed: 'Failed to update sorting',
            },
            orderBy: {
                position: 'Manual (drag & drop)',
                nameAsc: 'Name (A-Z)',
                nameDesc: 'Name (Z-A)',
                createdAsc: 'Created (oldest first)',
                createdDesc: 'Created (newest first)',
                durationAsc: 'Duration (shortest first)',
                durationDesc: 'Duration (longest first)',
            },
            smartRules: {
                maxItems: 'Maximum items',
                assetTypes: 'Asset types',
                assetTypesHint: 'Leave empty to include all types',
                types: { video: 'Video', image: 'Image', audio: 'Audio', document: 'Document' },
                includeTags: 'Include tags',
                excludeTags: 'Exclude tags',
                selectTags: 'Select tags...',
                matchAll: 'Match ALL',
                matchAny: 'Match ANY',
                orderBy: {
                    title: 'Sort order',
                    newestFirst: 'Newest first',
                    oldestFirst: 'Oldest first',
                    nameAsc: 'Name (A-Z)',
                    nameDesc: 'Name (Z-A)',
                    longestFirst: 'Longest first',
                    shortestFirst: 'Shortest first',
                },
                preview: 'Preview',
                apply: 'Apply rules',
                updated: 'Rules updated',
                updateFailed: 'Failed to update rules',
                previewFailed: 'Failed to preview rules',
            },
            preview: {
                title: 'Preview',
                noItems: 'No items',
                itemCount: {
                    one: '1 item',
                    other: '{count} items',
                },
                emptyHint: 'Items will appear here',
            },
        },
    },
    list: {
        name: 'Name',
        type: 'Type',
        duration: 'Duration',
        size: 'Size',
        date: 'Date',
        workspace: 'Workspace',
    },
    fileSelector: {
        selectFile: 'Select a file',
        selectFiles: 'Select files',
        search: 'Search...',
        searchWorkspaces: 'Search workspaces...',
        searchInFolder: 'Search in this folder...',
        allWorkspaces: 'All workspaces',
        files: 'files',
        noWorkspacesFound: 'No workspaces found',
        error: 'Error loading assets',
        empty: 'No assets found',
        noResults: 'No assets match your search',
        selectedSingular: 'selected',
        selectedPlural: 'selected',
        sources: 'Sources',
        quickAccess: 'Quick access',
        itemSelected: 'item selected',
        itemsSelected: 'items selected',
        clearSelection: 'Clear',
        confirmSelection: 'Confirm selection',
        maxSelectionHint: 'Select up to {max} files',
        multipleHint: 'Click on files to select them',
        clearSearch: 'Clear search',
        emptyTitle: 'No files here',
        emptyDescription: 'This folder is empty. Navigate to another folder or workspace.',
        noResultsTitle: 'No results',
        noResultsDescription: 'No files match your search criteria.',
        speechOnlyHint: 'Only content that contains speech is shown.',
        errorTitle: 'An error occurred',
        errorDescription: 'Unable to load your media. This can be temporary — please try again.',
        retry: 'Retry',
        workspacesError: 'Unable to load workspaces',
        emptyLibraryTitle: 'Your media library is empty',
        emptyLibraryDescription: 'Import files into Mediasbox first. Your media will then appear here so you can add it.',
        items: 'items',
        activeFilters: 'Filtered',
        alreadyAdded: 'Already added',
        filterBy: 'Filter by:',
        flatView: 'All files',
        flatViewTooltip: 'Show all files without folders',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        addFolderContents: 'Add folder contents',
        addFolderWithSubfolders: 'Add all contents (incl. subfolders)',
        folderAdded: '{count} items added from folder',
        folderAllAlreadyAdded: 'All items in this folder are already in the collection',
        folderAllAlreadySelected: 'All items in this folder are already selected',
        filters: {
            hasSpeech: 'With speech',
        },
    },
    types: {
        video: 'Video',
        audio: 'Audio',
        image: 'Image',
        document: 'Document',
        folder: 'Folder',
        collection: 'Collection',
        third_party: 'External video',
    },
    folderBrowser: {
        emptyFolder: 'This folder is empty',
        navigateHint: 'Double-click to navigate into folder',
    },
    share: {
        action: 'Share',
        existingError: 'The links already made for this file could not be read.',
        title: 'Share assets',
        subtitle: 'Create a public link to share your files',
        filesColumn: 'Files',
        createLink: 'Create share link',
        creating: 'Creating link…',
        regenerate: 'Regenerate new link',
        steps: {
            preview: 'Selection',
            options: 'Options',
            result: 'Share link',
        },
        validation: {
            noAssets: 'No assets selected',
        },
        preview: {
            title: 'Items to share',
            itemCount: '{count} item | {count} items',
            selectedCount: '{count} item selected | {count} items selected',
            types: {
                video: 'Video',
                image: 'Image',
                audio: 'Audio',
                folder: 'Folder',
                other: 'File',
            },
            folderNotice: 'Shared folders will include all their contents.',
        },
        options: {
            basicInfo: 'Basic information',
            name: 'Link name',
            namePlaceholder: 'e.g. Client review',
            defaultName: 'Share of {date}',
            nameRequired: 'Name is required',
            description: 'Description',
            descriptionPlaceholder: 'Optional notes for this share...',
            permissions: 'Permissions',
            allowDownload: 'Allow downloads',
            allowDownloadHint: 'Recipients can download the original files',
            security: 'Security',
            passwordProtection: 'Password protection',
            passwordHint: 'Require a password to access this share',
            passwordEnable: 'Require password',
            password: 'Password',
            passwordPlaceholder: 'Enter a password',
            limits: 'Limits',
            expiration: 'Expiration',
            expirationHint: 'By default the link expires in {count} day — disable or change the date for a longer-lived link | By default the link expires in {count} days — disable or change the date for a longer-lived link',
            expiresInDays: 'Expires in {count} day | Expires in {count} days',
            expiredBadge: 'Expired',
            expirationNone: 'Never expires',
            expirationCustom: 'Expires on',
            expirationDate: 'Expiration date',
            maxViews: 'Open limit',
            maxViewsHint: 'Limit the number of times this share can be opened',
            maxViewsUnlimited: 'Unlimited',
            maxViewsCustom: 'Limited to',
            maxViewsLabel: 'Maximum opens',
            maxViewsSuffix: 'opens',
            display: 'Display',
            hideAssetInfo: 'Hide asset details',
            hideAssetInfoHint: 'Hide title, description, and duration on the public page',
            hideDate: 'Hide date',
            hideDateHint: 'Hide the creation date on the public page',
            status: 'Status',
        },
        existingLink: {
            title: 'You are editing an already shared link',
            subtitle: 'Any change will be immediately visible to anyone who has this link.',
        },
        result: {
            copy: 'Copy',
            copied: 'Copied!',
            historyTitle: 'My share links',
            historySubtitle: 'View and manage all your previously created links',
            historyTitleAsset: 'Share links of this asset',
            historySubtitleAsset: 'View and manage every link made for this asset',
        },
        email: {
            tabLink: 'Share link',
            tabEmail: 'Send by email',
            new: 'New',
            recipients: 'Recipients',
            recipientsPlaceholder: 'Add an email…',
            subject: 'Subject',
            subjectDefault: 'Files shared with you — {name}',
            message: 'Message',
            messagePlaceholder: 'Add a personal note (optional)…',
            filesHeading: 'Files',
            optionsLabel: 'Send options',
            openLimit: 'Open limit per recipient',
            openLimitHint: 'Each recipient gets a personal link, openable a limited number of times',
            replyToHint: 'Each recipient gets a personal link — replies come to your address, with per-person open & click tracking.',
            send: 'Send to {count} recipient | Send to {count} recipients',
            sendEmpty: 'Send',
            sending: 'Sending…',
            success: 'Email sent to {count} recipient | Email sent to {count} recipients',
            error: 'Failed to send the email',
            tooMany: 'You can send to at most {max} recipients',
            invalidEmails: 'Some addresses are not valid emails',
        },
        error: 'Failed to create share link',
    },
    moderation: {
        title: 'Moderation',
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
        exempted: 'Exempted',
        filterAll: 'All',
        selected: 'selected',
        approve: 'Approve',
        reject: 'Reject',
        resetPending: 'Set back to pending',
        approveSelected: 'Approve selected',
        rejectSelected: 'Reject selected',
        rejectTitle: 'Reject assets',
        rejectReason: 'Reason for rejection',
        rejectReasonPlaceholder: 'Explain why these assets are being rejected...',
        noAssets: 'No assets to moderate',
        noAssetsDescription: 'All assets in this workspace have been reviewed.',
        name: 'Name',
        type: 'Type',
        date: 'Date',
        status: 'Status',
        actions: 'Actions',
        view: 'View',
        searchPlaceholder: 'Search assets...',
        approveSuccessSingle: 'Asset approved — now visible in this workspace',
        approveSuccessMultiple: '{count} assets approved — now visible in this workspace',
        approveError: 'Failed to approve assets',
        rejectSuccessSingle: 'Asset rejected',
        rejectSuccessMultiple: '{count} assets rejected',
        rejectError: 'Failed to reject assets',
        resetSelected: 'Set selected back to pending',
        resetSuccessSingle: 'Asset set back to pending',
        resetSuccessMultiple: '{count} assets set back to pending',
        resetError: 'Failed to set the assets back to pending',
        rejectReasonOptional: 'Reason for rejection (optional)',
        poolHint: 'Approving an asset of the shared pool validates it: it becomes read-only for everyone but the pool\'s moderators. Setting it back to pending makes it editable again.',
        loadError: 'Could not load the moderation queue.',
        loadMore: 'Show more',
        noRejected: 'No rejected assets',
        noRejectedDescription: 'Nothing has been turned away in this workspace.',
        noApproved: 'No approved assets',
        noApprovedDescription: 'Nothing has been approved in this workspace yet.',
        revisions: 'Revisions',
        approveRevision: 'Approve the changes',
        saveAmendmentsFirst: 'Save your amendments first: the approval applies the draft as saved.',
        changedFields: 'Changed:',
        draftFields: {
            excerpt: 'Excerpt',
            rights: 'Rights',
            language: 'Language',
            metadata: 'Metadata ({count}) | Metadata ({count})',
        },
        rejectRevision: 'Refuse the changes',
        rejectRevisionTitle: 'Refuse the changes',
        rejectRevisionLead: 'The video stays validated and visible. The changes are sent back to {name} with your message, to fix them and submit again.',
        rejectRevisionDone: 'Changes refused: they were sent back with your message.',
        approvedIn: 'Approved in “{workspace}”',
        approvedUnstamped: 'Approved',
        withdrawApproval: 'Withdraw approval',
        withdrawTitle: 'Withdraw the approval?',
        withdrawLead: 'The asset goes back to pending: members of “{workspace}” no longer see it until a new decision.',
        withdrawUnlocks: 'Whoever the validation locked out can edit it again.',
        withdrawDone: 'Approval withdrawn: the asset is pending again',
        banner: {
            pending: 'Awaiting approval',
            rejected: 'Rejected',
            revision: 'Changes to approve',
            approved: 'Approved',
        },
        noRevisions: 'No revision in progress',
        noRevisionsDescription: 'No validated asset is being changed.',
        lastDecision: 'Last decision',
        neverDecided: 'No decision yet',
        quick: {
            more: 'More actions',
            rejectWithReason: 'Reject with a reason',
            approveRevision: 'Validate',
            rejectRevision: 'Refuse',
            revisionApproved: 'Changes validated',
        },
        reasonLine: 'Reason: {reason}',
        formerMember: 'a former member',
        uploadedBy: 'Uploaded by {name}',
        uploadedByFrom: 'Uploaded by {name} from {workspace}',
        depositedVia: 'Deposited by {name} via {channel}',
        decisionLine: {
            pending: 'Set back to pending on {date} by {name}',
            approved: 'Approved on {date} by {name}',
            rejected: 'Rejected on {date} by {name}',
            exempted: 'Exempted on {date}',
        },
        submittedLine: 'Changes submitted on {date} by {name}',
        outcomeSummary: '{decided} decided, {unchanged} already in that state, {notPlaced} not in this workspace',
        notModerated: 'This workspace does not moderate its assets: turn moderation on in its settings.',
        reasonRequired: 'Your organization requires a reason for every rejection.',
        moderationCard: {
            pendingLabel: 'Pending review — {name}',
            approvedLabel: 'Approved — {name}',
            rejectedLabel: 'Rejected — {name}',
            pendingDescription: 'This asset is awaiting approval before being visible.',
            approvedDescription: 'This asset has been approved and is visible.',
            rejectedDescription: 'This asset has been rejected and is hidden.',
            viewReason: 'View reason',
            rejectionReasonTitle: 'Rejection reason',
            approveSuccess: 'Asset approved',
            rejectSuccess: 'Asset rejected',
            resetPendingSuccess: 'Asset set back to pending',
            approveError: 'Failed to approve asset',
            rejectError: 'Failed to reject asset',
            resetPendingError: 'Failed to reset asset to pending',
        },
    },
    validation: {
        lockedLabel: 'Validated — read-only',
        validated: 'Validated',
        validatedBy: 'Validated by {name}',
        validatedOn: 'Validated on {date}',
        validatedByOn: 'Validated by {name} on {date}',
        banner: {
            locked: { title: 'Validated in the shared pool', subtitle: 'read-only' },
            editing: { title: 'Draft in progress', subtitle: 'your changes stay in your draft: the asset does not change until a moderator approves them' },
            othersDraft: { title: 'Changes in progress', subtitle: 'only its author can change this draft, submit it or abandon it' },
            returned: { title: 'Changes refused', subtitle: 'fix them, then submit again' },
            submitted: { title: 'Changes submitted', status: 'Awaiting approval' },
        },
        rejection: {
            titleByOn: 'Your changes were refused by {name} on {date}',
            titleOn: 'Your changes were refused on {date}',
            hint: 'The asset did not change. Fix your draft and submit it again, or abandon it.',
            dismiss: 'Close the message',
        },
        unsaved: {
            title: 'Unsaved changes',
            text: 'You have changes you have not saved. If you leave this tab, they will be lost.',
            stay: 'Stay and save',
            leave: 'Leave without saving',
            beforeSubmit: 'Save your changes first in: {tabs}. Otherwise they will not be part of what you submit.',
        },
        changed: 'Changed',
        before: 'Before:',
        emptyValue: '(empty)',
        revert: 'Revert',
        submittedLabel: 'Awaiting approval',
        revisionSubmittedByOn: 'Submitted by {name} on {date}',
        revisionSubmittedOn: 'Submitted on {date}',
        submitAction: 'Submit for approval',
        resubmitAction: 'Submit again',
        submitTitle: 'Submit your changes',
        submitLead: 'Describe what you changed: it is what the shared pool’s moderators will read to approve it.',
        submitReason: 'What did you change?',
        submitReasonPlaceholder: 'For example: title fixed, new thumbnail, subtitles added',
        submitNote: 'Your draft can no longer be changed or abandoned until the moderators decide.',
        submitConfirm: 'Submit',
        submitDone: 'Changes submitted to the shared pool’s moderators.',
        submitError: 'Could not submit the changes.',
        abandonAction: 'Abandon',
        abandonTitle: 'Abandon the draft?',
        abandonText: 'Your changes will be lost. The asset stays as it was validated.',
        abandonConfirm: 'Abandon the draft',
        abandonDone: 'Draft abandoned.',
        abandonError: 'Could not abandon the draft.',
        draftSaved: 'Draft saved.',
        draftSaveError: 'Could not save the draft.',
        revisionLead: 'This asset was validated by the shared pool’s moderators. Here is what happens if you edit it:',
        revisionSteps: {
            edit: { title: 'You write a draft', text: 'Title, description, tags and metadata are edited as usual, but in your draft. Nothing is sent until you submit.' },
            visible: { title: 'The asset does not change', text: 'It stays visible in the shared pool as it was validated, for everybody.' },
            review: { title: 'A moderator approves', text: 'When you submit, a moderator compares and approves: your changes are then applied to the asset.' },
        },
        revisionLabel: 'Being changed',
        revisionByOn: 'Started by {name} on {date}',
        revisionOn: 'Started on {date}',
        revisionReasonLine: '“{reason}”',
        revisionHint: 'Changes to this asset are proposed: it stays visible as it was validated until they are approved.',
        revisionOnisepNote: 'ONISEP keeps the version it already has and is sent your changes only once they are approved.',
        revisionLiftsHint: 'Its owner is proposing changes: once submitted, approve them from the moderation’s Revisions tab or from this page.',
        reviseAction: 'Edit',
        revisionTitle: 'Edit a validated asset',
        revisionConfirm: 'Open a draft',
        revisionOpened: 'Draft opened: edit the record, then submit it when you are done.',
        revisionError: 'Could not open this asset for editing.',
        bindsHint: 'Validated in the shared pool, this asset is read-only. Only a moderator of the pool can change it, or set it back to pending to make it editable.',
        liftsHint: 'You moderate the shared pool: you keep every right. Setting it back to pending makes it editable by the others.',
        selectionLocked: 'The selection holds an asset validated in the shared pool: only a moderator of the pool can move or delete it.',
        deletionLocked: 'Cannot delete: the selection, folders included, holds {count} asset validated in the shared pool. Only a moderator of the pool can delete it. | Cannot delete: the selection, folders included, holds {count} assets validated in the shared pool. Only a moderator of the pool can delete them.',
        unlockedLabel: 'Validation',
        lockedDescription: 'This asset has been validated and is locked. Editing is disabled for everyone except administrators.',
        lockedBy: 'Validated by {name}. Editing is locked for everyone else.',
        lockedByOn: 'Validated by {name} on {date}. Editing is locked for everyone else.',
        unlockedDescription: 'Validate this asset to lock it in read-only mode for all other members, including the uploader.',
        validateAction: 'Validate & lock',
        unlockAction: 'Unlock',
        validateSuccess: 'Asset validated and locked',
        validateError: 'Failed to validate the asset',
        unlockSuccess: 'Asset unlocked',
        unlockError: 'Failed to unlock the asset',
    },
    storage: {
        title: 'Storage Details',
        loadError: 'Failed to load storage statistics',
        videoSection: 'Videos',
        videoDescription: 'Video content storage',
        audioSection: 'Audio',
        audioDescription: 'Audio content storage',
        filesSection: 'Other Files',
        filesDescription: 'Images, documents and other files',
        totalDuration: 'Total duration',
        totalSize: 'Total size',
        fileCount: 'Files',
        files: 'files',
        noOtherFiles: 'No other files stored',
        totalStorage: 'Total storage used',
        costs: {
            title: 'By category',
            subtitle: 'What each part of the storage costs every month, at today\'s prices.',
            volumesOnly: 'The volumes, without the amounts.',
            total: 'Estimated monthly total',
            perMonth: '{amount}/month',
            rates: '{hour} per hour of video and {gigabyte} per GB, every month',
            ratesBytes: '{gigabyte} per GB every month, videos included by the GB of their sources',
            categories: {
                video: { label: 'Videos' },
                old_versions: { label: 'Old versions' },
                sources: { label: 'Video sources, every version included' },
                renditions: { label: 'Encoded versions' },
                audio: { label: 'Audio' },
                files: { label: 'Other files' },
                trash: { label: 'Trash' },
            },
        },
        types: {
            images: 'Images',
            documents: 'Documents',
            files: 'Other files',
            archives: 'Archives',
            subtitles: 'Subtitles',
            collections: 'Collections',
            thirdParty: 'External videos',
            other: 'Other',
        },
    },
    embed: {
        title: 'Embed',
        publicationError: 'Could not prepare this media\'s embed code.',
        instruction: 'Copy this code and paste it on your website',
        integrationGroup: 'Integration',
        dimensionsGroup: 'Dimensions',
        optionsGroup: 'Options & playback',
        preset: 'Preset',
        presetHint: 'The chosen preset is written into the code; without a choice, the default one applies. Nothing is saved.',
        dimensions: 'Dimensions',
        responsive: 'Responsive width',
        responsiveRecommended: 'Responsive width (recommended)',
        responsiveDesc: 'The player will automatically fill the width of its container',
        aspectRatio: 'Aspect ratio',
        aspectRatioCustom: 'Custom',
        fluidWidthHint: 'Width: 100% of the container',
        width: 'Width',
        height: 'Height',
        options: 'Options',
        integration: 'Integration',
        autoResize: 'Auto-resize',
        autoResizeDesc: 'Automatically adjusts iframe height to fit the player content (requires a small script alongside the iframe)',
        embedMethod: 'Embed method',
        embedMethodScript: 'Script',
        embedMethodScriptDesc: 'Modern embed: auto-resize, JS API, patchable server-side.',
        embedMethodIframe: 'Iframe',
        embedMethodIframeDesc: 'Legacy iframe snippet. Use on sites that block third-party scripts.',
        display: 'Display',
        displayInline: 'In the page',
        displayInlineDesc: 'The player is embedded directly in the page.',
        displayPopover: 'Button',
        displayPopoverDesc: 'A trigger opens the video in a fullscreen overlay on click. The video only loads when clicked.',
        trigger: 'Trigger',
        triggerButton: 'Button',
        triggerThumbnail: 'Thumbnail',
        triggerLabel: 'Button label',
        triggerLabelPlaceholder: 'Watch video',
        triggerPreview: 'Preview',
        triggerPreviewHint: 'Click to preview the popup.',
        triggerThumbnailUsesPoster: "Uses the asset's thumbnail with a centered play button.",
        triggerThumbnailNoPoster: 'No thumbnail available for this asset — the trigger will show a play button on a neutral background.',
        copyCode: 'Copy code',
        copied: 'Code copied!',
        videoLinkBadge: 'Link',
        openInTab: 'See it in a new tab',
        advancedOptions: 'Advanced options',
        advancedOptionsDesc: 'All customization settings on the Developer tab',
        adaptToPlatform: 'Adapt it to my platform',
        destinationTrace: 'For {destination} · change',
        presetLabel: 'Preset',
        presetHint: 'Your colors, logo and options saved once, to reuse from one media to the next.',
        assistant: {
            pickerLabel: 'For',
            menuOther: 'Other destinations',
            menuChange: '{destination} — change destination',
            menuGroups: {
                html: 'Paste HTML',
                link: 'Paste a link',
            },
            deliverySnippet: 'The code to paste',
            deliveryUrl: 'The URL to paste',
            deliveryEmail: 'The block to paste into your email',
            advanced: 'Advanced settings',
            advancedHint: 'Method, dimensions, playback options, presets',
            destinations: {
                web: {
                    label: 'Website',
                    note: 'A responsive 16:9 player: it fills the width of your page and stays readable on phones.',
                    steps: 'Paste this code into your page\'s HTML, exactly where the player should appear. If your editor has an HTML mode, switch to it before pasting.',
                },
                wordpress: {
                    label: 'WordPress',
                    note: 'The Script code works in WordPress, as long as you paste it into an HTML block rather than the visual editor.',
                    steps: 'Gutenberg editor: add a "Custom HTML" block and paste the code into it. Classic editor: switch to the "Text" tab, then paste.',
                    caveat: 'There is no Videas plugin or shortcode for WordPress yet — an HTML block is how you embed today.',
                },
                newsletter: {
                    label: 'Newsletter',
                    note: 'Email clients block video players, so here is a clickable thumbnail that opens the media in the browser instead — it works in every inbox.',
                    steps: 'Paste this block into your newsletter\'s HTML editor — the "Code" block in Mailchimp, Brevo or Mailjet.',
                },
                wix: {
                    label: 'Wix',
                    note: 'Wix often blocks external scripts, so here is an iframe instead — it depends on no JavaScript.',
                    steps: 'Add a "Custom HTML" element to your page, then paste the code into it.',
                    caveat: 'Opening from a button is not available here: it needs our script, which Wix blocks. The player shows directly in the page instead.',
                },
                squarespace: {
                    label: 'Squarespace',
                    note: 'A responsive 16:9 player: it fills the width of your page and stays readable on phones.',
                    steps: 'Add a "Code" block to your page, then paste the code into it.',
                },
                webflow: {
                    label: 'Webflow',
                    note: 'A responsive 16:9 player: it fills the width of your page and stays readable on phones.',
                    steps: 'Drag an "Embed" element into your page, then paste the code into it.',
                },
                wiki: {
                    label: 'Internal wiki',
                    note: 'Confluence and most intranets filter JavaScript, so here is an iframe instead — it needs none.',
                    steps: 'Paste this code into an HTML block on your page.',
                    caveat: 'Opening from a button is not available here: it needs our script, which these tools filter out. The player shows directly in the page instead.',
                },
                notion: {
                    label: 'Notion',
                    note: 'Notion does not accept script tags: it needs the bare URL, which it turns into a player itself.',
                    steps: 'In your page, type /embed, paste this URL, then confirm.',
                    caveat: 'On a corporate wiki that refuses the URL, pick "Internal wiki" instead: you will get an iframe.',
                },
            },
            recap: {
                methodScript: 'Script code',
                methodIframe: 'Iframe code',
                displayPopover: 'Button that opens the player',
                responsive: 'Responsive width',
                fixedWidth: 'Width {width} px',
                ratio: 'Aspect ratio {ratio}',
                clickableThumbnail: 'Clickable thumbnail',
                textLink: 'Text link',
                opensInBrowser: 'Opens the media in the browser',
                bareUrl: 'Bare URL',
                hostBuildsPlayer: 'Notion builds the player',
            },
            email: {
                ctaVideo: 'Watch the video',
                ctaMedia: 'View the content',
                noThumbnail: 'This media has no thumbnail, so the block is a text link only. Add a thumbnail to the media to get a clickable image.',
                domainRestriction: 'If you have restricted the domains allowed to show this player, this link will not open from an inbox: a click inside an email carries no origin domain.',
            },
        },
    },
    playerSettings: {
        title: 'Player settings',
        presetName: 'My player',
        preview: 'Preview',
        appearance: 'Appearance',
        theme: 'Theme',
        accent: 'Accent color',
        accentCustom: 'Custom color',
        accentReset: 'Reset',
        colorfulHint: 'The "Color" theme blurs the cover art behind the controls. It only exists for audio.',
        logo: 'Logo',
        logoHelper: 'It appears as a watermark on your players, and serves every media type.',
        logoInherited: 'This logo comes from the organization settings. Choosing one here will apply to this workspace only.',
        showLogo: 'Show the logo',
        showLogoHint: 'As a watermark on the player',
        showLogoEmpty: 'Choose a logo above first',
        logoOnPlay: 'The watermark appears once playback starts — never on the poster frame.',
        logoPosition: 'Position',
        positions: {
            top_left: 'Top left',
            top_right: 'Top right',
            bottom_left: 'Bottom left',
            bottom_right: 'Bottom right',
            control_bar: 'Control bar',
        },
        logoPositionNote: {
            audio: 'On an audio player the logo sits in the header: there is no position to choose.',
            pinned: 'For this media type the logo is pinned to the bottom right.',
        },
        behaviour: 'Behavior',
        toggles: {
            ecoModeDefault: {
                label: 'Eco mode by default',
                hint: 'Starts at reduced quality',
            },
        },
        locked: 'Player customization is locked for this workspace. You can see the settings, not change them.',
        advanced: 'Advanced settings',
        scope: 'These settings become your default player for this media type: they also apply to embeds already online that carry no settings of their own. The logo is a workspace setting — it applies to every media type at once.',
        snippetOptions: 'Autoplay, loop, sound and the other playback options are written into the embed code itself, not into your settings. {help}',
        snippetOptionsLink: 'See every player parameter',
        saveError: 'The settings could not be saved. Try again in a moment.',
        subtitle: {
            video: 'Color, logo and behavior of all your video players.',
            audio: 'Color, logo and behavior of all your audio players.',
            image: 'Theme, logo and behavior of all your embedded images.',
            document: 'Logo and behavior of all your embedded documents.',
            collection: 'Color, logo and behavior of all your embedded collections.',
        },
        previewNote: {
            video: 'This is the real player, not a picture: what you see here is what your visitors will see.',
            audio: 'The "Color" theme uses the cover art as a background. It is the default theme for audio.',
            image: 'An embedded image has no accent color: only the theme and the logo apply.',
            document: 'An embedded document has neither theme nor accent color: only the logo applies.',
        },
        accentEmpty: {
            video: 'With no color chosen, the player falls back to the platform color.',
            audio: 'With no color chosen, the accent is taken from the media cover art.',
        },
    },
    developer: {
        title: 'Developer',
        subtitle: 'Embed, integrate, and access this asset programmatically',
        error: {
            title: 'Loading error',
            description: 'Unable to load embed information',
            retry: 'Retry',
        },
        notEmbeddable: {
            title: 'Embed not available',
            description: 'This asset type does not support embedding. Only videos, audios, images, documents, and collections can be embedded.',
        },
        unavailable: {
            title: 'Embed not available',
            description: 'This media has no embed code yet, and your role in this workspace cannot create one.',
        },
        advanced: {
            title: 'Advanced',
            description: 'What you set once and leave alone.',
        },
        sourceDownload: {
            label: 'Allow source download',
            hint: 'Shows a download button in the player. Applies to every code already embedded, without changing them.',
            hintCollection: 'In a playlist, this lets the viewer download each video, one at a time.',
            readOnly: 'Only someone who can share this content can change this setting.',
            saved: 'Source download saved',
            saveError: 'Could not save the source download',
        },
        advertising: {
            label: 'Show ads',
            hint: 'On by default as soon as advertising is set up. Applies to every code already embedded, without changing them.',
            readOnly: 'Only someone who can edit this content can change this setting.',
            saved: 'Advertising saved',
            saveError: 'Could not save the advertising',
        },
        access: {
            title: 'Player access',
            description: 'Who may show this player, and where.',
            levels: {
                public: 'Public',
                publicDescription: 'Shows on any site.',
                domainRestricted: 'Allowed domains',
                domainRestrictedDescription: 'Shows only on the sites you list.',
                tokenRequired: 'Access token',
                tokenRequiredDescription: 'Opens only with a token added to the code.',
            },
            domains: 'Domains',
            domainsPlaceholder: 'example.com',
            domainsHint: 'Press Enter or type a comma to add a domain; *.example.com covers every subdomain.',
            workspaceNote: 'The workspace\'s domain list applies on top of this setting.',
            codeHint: 'This player will not show everywhere.',
            edit: 'Edit access',
            cancel: 'Cancel',
            save: 'Save',
            saved: 'Access saved',
            saveError: 'Could not save the access',
            howto: {
                title: 'How does it work?',
                step1: 'Create one token per allowed site or partner.',
                step2: 'Copy the code shown when it is created: it already carries the token, and the recipient pastes it as is.',
                step3: 'Revoke a token to cut that site\'s access alone, leaving the others untouched.',
                caveat: 'The token stays readable in the source of the site that embeds it: it identifies a partner, it does not stop a copy. To keep the player on your own sites, choose allowed domains.',
            },
            summary: {
                public: 'Public',
                domains: 'No domain | 1 domain | {n} domains',
                tokens: 'Token required',
                tokensActive: 'Token required · none active | Token required · 1 active | Token required · {n} active',
            },
            tokens: {
                title: 'Access tokens',
                description: 'One token per site or partner, revocable at any time.',
                empty: 'No token for this player.',
                labelPlaceholder: 'Recipient, such as Partner site',
                unnamed: 'Unnamed',
                createdOn: 'Created {date}',
                create: 'Create a token',
                revoke: 'Revoke',
                revoked: 'Revoked',
                active: 'Active',
                secretTitle: 'Copy this token now',
                secretDescription: 'It will not be shown again. Here is the embed code that already carries it, ready to paste on the recipient\'s site.',
                copy: 'Copy',
                copyCode: 'Copy the code',
                codeCopied: 'Code copied',
                secretLabel: 'Token only',
                copied: 'Token copied',
                dismiss: 'Dismiss',
                createError: 'Could not create the token',
                revokeError: 'Could not revoke the token',
            },
        },
        settings: {
            saved: 'Settings saved',
            saveError: 'Failed to save settings',
        },
        embedCode: {
            title: 'Embed code',
            copyCode: 'Copy code',
            copyCodeAgain: 'Copy updated code',
            copied: 'Copied!',
            copyError: 'Failed to copy',
            showPreview: 'Preview',
            hidePreview: 'Hide preview',
            codeUpdated: 'Embed code updated — your changes are reflected in the code above.',
            scrollToCode: 'Copy code',
        },
        customize: {
            title: 'Player settings',
            description: 'Configure the appearance and behavior of the player.',
            dimensions: 'Dimensions',
            responsive: 'Responsive width',
            responsiveDesc: 'The player will fill the width of its container',
            aspectRatio: 'Aspect ratio',
            aspectRatioCustom: 'Custom',
            aspectRatioCustomLabel: 'Custom ratio (W : H)',
            fluidWidthHint: 'Width: 100% of the container',
            integrationGroup: 'Integration',
            dimensionsGroup: 'Dimensions',
            playbackGroup: 'Playback & behaviour',
            embedMethod: 'Embed method',
            embedMethodDesc: 'Script is recommended and works on any page. Use iframe as a fallback on strict-CSP sites.',
            embedMethodScript: 'Script',
            embedMethodScriptDesc: 'Modern embed: auto-resize, JS API, patchable server-side.',
            embedMethodIframe: 'Iframe',
            embedMethodIframeDesc: 'Legacy iframe snippet. Use on sites that block third-party scripts.',
            display: 'Display',
            displayDesc: 'Inline embeds the player in the page; popover opens it in a fullscreen overlay on click (the video only loads when clicked).',
            displayInline: 'Inline',
            displayPopover: 'Popover',
            trigger: 'Trigger',
            triggerDesc: 'What the visitor clicks to open the popover.',
            triggerButton: 'Button',
            triggerThumbnail: 'Thumbnail',
            triggerLabel: 'Button label',
            triggerLabelDesc: 'Leave empty to auto-translate to the visitor\'s language.',
            triggerLabelPlaceholder: 'Watch video',
            triggerPreview: 'Preview',
            triggerPreviewHint: 'Click to preview the popup.',
            triggerThumbnailLabel: 'Thumbnail',
            triggerThumbnailUsesPoster: "Uses the asset's thumbnail with a centered play button.",
            triggerThumbnailNoPoster: 'No thumbnail available — the trigger shows a play button on a neutral background.',
            width: 'Width',
            height: 'Height',
            autoResize: 'Auto-resize',
            autoResizeDesc: 'Automatically adjusts iframe height to fit the player content (requires a small script alongside the iframe)',
            options: 'Options',
        },
        options: {
            startAt: 'Start at',
            startAtDesc: 'Start playback at a specific time (e.g. 1:30 or 90)',
            autoplay: 'Autoplay',
            autoplayDesc: 'Start playing automatically when the page loads',
            autoplayMutedWarning: 'Browsers block autoplay with sound. Enable "Muted" for autoplay to work reliably.',
            loop: 'Loop',
            loopDesc: 'Restart playback when it reaches the end',
            muted: 'Muted',
            mutedDesc: 'Start with audio muted (required for autoplay in most browsers)',
            controls: 'Controls',
            controlsDesc: 'Show playback controls to the viewer',
            pinControls: 'Pin controls',
            pinControlsDesc: 'Keep the control bar always visible (disables auto-hide)',
            seeking: 'Seeking',
            seekingDesc: 'Let the viewer skip forward or back with the progress bar, the keyboard or the chapters. Off, playback is followed from start to end; resuming where they stopped is still offered',
            showChapters: 'Show chapters',
            showChaptersDesc: 'Display chapter markers on the progress bar',
            enablePip: 'Picture-in-picture',
            enablePipDesc: 'Allow the viewer to use picture-in-picture mode',
            enableFullscreen: 'Fullscreen',
            enableFullscreenDesc: 'Allow the viewer to enter fullscreen mode',
            shuffle: 'Shuffle',
            shuffleDesc: 'Play tracks in random order',
            showWaveform: 'Show waveform',
            showWaveformDesc: 'Display the audio waveform visualization',
            showPlaylist: 'Show playlist',
            showPlaylistDesc: 'Display the playlist panel for multi-track embeds',
            enableZoom: 'Enable zoom',
            enableZoomDesc: 'Allow the viewer to zoom into the image',
            allowDownload: 'Allow download',
            allowDownloadDesc: 'Allow viewers to download the original file',
            showCaption: 'Show caption',
            showCaptionDesc: 'Display the asset name as a caption below the player',
            startPage: 'Start page',
            startPageDesc: 'Open the document at a specific page number',
            showThumbnails: 'Show thumbnails',
            showThumbnailsDesc: 'Display a thumbnail sidebar or strip',
            showOutline: 'Show outline',
            showOutlineDesc: 'Display the document table of contents',
            autoplayNext: 'Auto-play next',
            autoplayNextDesc: 'Automatically play the next item in the collection',
            showAds: 'Show ads',
            showAdsDesc: 'Play advertising configured on this embed',
            displayMode: 'Display mode',
            displayModeDesc: 'How the collection playlist is displayed alongside the player',
            displayModeDrawer: 'Default',
            displayModeDrawerDesc: 'Playlist opens as an overlay drawer',
            displayModeBottomBar: 'Bottom bar',
            displayModeBottomBarDesc: 'Thumbnail strip below the player',
            displayModeSidebar: 'Sidebar',
            displayModeSidebarDesc: 'Vertical thumbnail strip on the side',
            posterFit: 'Poster fit',
            posterFitDesc: 'How the thumbnail fills the player area before playback',
            posterFitContain: 'Fit',
            posterFitCover: 'Fill',
            audioTheme: 'Player theme',
            audioThemeDesc: 'Choose the visual appearance of the audio player',
            themeLight: 'Light',
            themeDark: 'Dark',
            themeColorful: 'Colorful',
            iconColor: 'Accent color',
            iconColorDesc: 'Custom accent color for the player (buttons, progress bar, waveform...)',
            iconColorReset: 'Reset',
            showHomepageInfo: 'Show homepage info',
            showHomepageInfoDesc: 'Display title and duration on the poster overlay',
            showHomepagePlayButton: 'Show play button',
            showHomepagePlayButtonDesc: 'Display the play button on the poster overlay',
            showEcoMode: 'Eco mode button',
            showEcoModeDesc: 'Show the eco mode toggle in the player',
            ecoModeDefault: 'Eco mode by default',
            ecoModeDefaultDesc: 'Start playback in eco mode (streaming quality capped at 720p)',
            showInfoButton: 'Info button',
            showInfoButtonDesc: 'Show the info button in the player',
            allowSourceDownload: 'Allow source download',
            allowSourceDownloadDesc: 'Allow viewers to download the original source file',
            enableSlideshow: 'Enable slideshow',
            enableSlideshowDesc: 'Allow automatic slideshow for image collections',
            slideshowDuration: 'Slideshow interval',
            slideshowDurationDesc: 'Time between slides in seconds',
            showCaptions: 'Show image titles',
            showCaptionsDesc: 'Show the current image title in carousel mode and under thumbnails in grid mode',
            enableSearch: 'Enable search',
            enableSearchDesc: 'Allow the viewer to search within the document',
        },
        presets: {
            title: 'Presets',
            descriptionNative: 'Choose the preset applied to this code. Without a choice, the workspace\'s default preset applies, otherwise the organization\'s.',
            descriptionAsset: 'This code publishes the media by its own ID. Choose a preset to write it into the code; without a choice, the workspace\'s default preset applies, otherwise the organization\'s. The choice is saved nowhere: it lives in the copied code.',
            label: 'Presets',
            placeholder: 'Select a preset...',
            save: 'Save preset',
            saveAs: 'Save as preset',
            customize: 'Customize',
            actions: 'Actions for preset "{name}"',
            chosenBadge: 'Chosen for this code',
            readOnlyHint: 'Only organization administrators can create or edit a preset.',
            appliedBanner: 'Preset "{name}" is chosen for this code.',
            appliedDefaultBanner: 'Default preset "{name}" applies to this code.',
            divergingHint: 'The settings changed below are added to the code on top of it.',
            resetToPreset: 'Restore preset',
            clearChoice: 'Remove this choice',
            appliedToast: 'Preset applied to this code',
            clearedToast: 'The default preset applies again',
            applyError: 'Could not apply the preset',
            saveError: 'Failed to save the preset',
            deleteError: 'Failed to delete the preset',
            logo: 'Preset logo',
            logoHint: 'Saved with the preset: the code carries no file. Without one, the player shows the workspace\'s.',
            saveDialog: {
                title: 'Save as preset',
                name: 'Preset name',
                namePlaceholder: 'e.g. Autoplay Muted',
                save: 'Save',
                cancel: 'Cancel',
                scope: 'Scope',
                scopeWorkspace: 'This workspace',
                scopeOrg: 'All workspaces (organization)',
                setAsDefault: 'Set as default preset',
                assetModeHint: 'As the default, it applies to every code of this type that names none. Otherwise it is chosen for this code.',
                logo: 'Logo',
                logoHint: 'Optional. Without one, the player shows the workspace\'s or the organization\'s.',
                deleteTitle: 'Delete preset',
                deleteConfirm: 'Are you sure you want to delete the preset "{name}"?',
            },
            rename: 'Rename',
            renameDialog: {
                title: 'Rename preset',
                name: 'Preset name',
                save: 'Rename',
            },
            update: 'Update preset',
            delete: 'Delete preset',
            deleteConfirm: 'Delete this preset?',
            hint: 'Settings modified —',
            hintAction: 'Save as preset',
            empty: 'No presets saved',
            saved: 'Preset saved',
            updated: 'Preset updated',
            deleted: 'Preset deleted',
            defaultBadge: 'Default',
            orgBadge: 'Organization',
            setDefault: 'Set as default',
            removeDefault: 'Remove default',
            promoteToOrg: 'Share with all workspaces',
            restrictToWorkspace: 'Restrict to this workspace',
            editingBanner: 'Editing preset "{name}" — changes are not saved yet.',
            editingMessage: 'Editing preset "{name}"',
            savePreset: 'Save preset',
        },
        appearance: {
            title: 'Appearance',
            description: 'Customize the visual appearance of the player.',
            themeGroup: 'Theme & color',
            logoGroup: 'Logo',
            playerTheme: 'Player theme',
            playerThemeDesc: 'Choose a light or dark appearance for the player panels and overlays',
            primaryColor: 'Primary color',
            primaryColorDesc: 'Custom primary color for the player controls and UI elements',
            primaryColorUrlHint: 'This color will be included in the embed URL.',
            resetColor: 'Reset',
            showLogo: 'Show logo',
            showLogoDesc: 'Display the workspace logo overlay on the player',
            logo: 'Logo',
            logoDesc: 'Display a custom logo overlay on the player',
            uploadLogo: 'Upload logo',
            removeLogo: 'Remove',
            logoPosition: 'Logo position',
            logoPositionDesc: 'Where to display the logo on the player',
            positionTopLeft: 'Top left',
            positionTopRight: 'Top right',
            positionBottomLeft: 'Bottom left',
            positionBottomRight: 'Bottom right',
            positionControlBar: 'Control bar',
            logoOpacity: 'Logo opacity',
            logoOpacityDesc: 'Transparency level of the logo overlay',
            logoClickUrl: 'Logo click URL',
            logoClickUrlDesc: 'URL to open when the viewer clicks the logo',
            logoClickUrlPlaceholder: 'https://example.com',
            noLogoHint: 'No player logo has been set yet, so nothing will appear on the player. Upload one in the {link}.',
            noLogoLink: 'workspace player settings',
        },
        links: {
            title: 'Direct links & IDs',
            description: 'Identifiers to reference this asset via the API.',
            assetId: 'Asset ID',
            embedId: 'Embed ID',
            embedUrl: 'Embed URL',
            sourceDownloadUrl: 'Permanent source file link',
            copy: 'Copy',
            copied: 'Copied!',
        },
        api: {
            title: 'API reference',
            description: 'Code examples for integration.',
            getEmbed: 'Get embed metadata',
            getEmbedDesc: 'Retrieve the items of this embed and a playback token valid for four hours',
            getPlayback: 'Get playback info',
            getPlaybackDesc: 'Retrieve an item\'s sources with the embed\'s playback token',
            copyCode: 'Copy',
            copied: 'Copied!',
        },
    },
    card: {
        smart: 'Smart',
        manual: 'Manual',
        itemCount: 'No items | {count} item | {count} items',
        encoding: 'Encoding',
        processing: 'Processing',
        uploading: 'Uploading',
        awaitingCredit: 'Awaiting credit',
        awaitingCreditHint: 'The organization\'s credit does not cover this video\'s first month of storage: it is not encoded yet. Top up your credit and the encoding resumes by itself; without a top-up, after seven days of waiting, it goes back to its previous version if it has one, and to the trash otherwise.',
    },
    assetTypes: {
        video: 'Video',
        image: 'Image',
        audio: 'Audio',
        document: 'Document',
        folder: 'Folder',
        file: 'File',
        collection: 'Collection',
        archive: 'Archive',
        subtitles: 'Subtitles',
        thirdParty: 'External video',
        other: 'Other',
        plurals: {
            videos: 'Videos',
            images: 'Images',
            audios: 'Audios',
            documents: 'Documents',
        },
    },
}
